<template>
    <div style="background-color: #fff;font-size: 15px !important;">
    <div class="activity-main">
         <!-- 头部 -->
      <headers></headers>
        <section class="ban-bg">

        </section>
        <section class="ban">
            <div class="col">
                <div>
                    <h1 class="title1">即刻加入平台会员 尊享众多精彩权益</h1>

                    <p style="
                    font-weight: 300;
                    font-size: 30px;
                    margin-top: 50px;
                    text-align: center;
                    color: #FFFFFF;
                    line-height: 60px;">会展云旗下众多数字化产品和增值服务，全面覆盖展装企业日常管理和市场拓展需要</p>
                </div>
            </div>
        </section>
        <div style="">
            <section class="col" style="padding-top: 50px;">
                <div class="div1" id="j-nav-10">
                    <a class="md jrwm active" href="javascript:;">加入我们</a>
                    <i></i>
                    <a class="md jrfs" href="#jrfs">加入方式</a>
                    <i></i>
                    <a class="md sqjr" href="#sqjr">申请加入</a>
                    <i></i>
                    <a class="md lxwm" href="#lxwm">联系我们</a>
                </div>
                <h4 class="title5" style="margin-top: 98px;margin-bottom: 20px;">加入优势</h4>
                <ul class="ul1">
                    <li>
                        <div>
                            <img src="../images/img-fj.png" alt="">
                            <p class="s1">抢占先机</p>
                            <p class="s2">全方位权益</p>
                            <p class="s3">进入平台自营&合作主场项目推荐搭建商行列，更快获得业务增长机会</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <img src="../images/img-ss.png" alt="">
                            <p class="s1">提升效率</p>
                            <p class="s2">数字化赋能</p>  
                            <p class="s3">展装云、设计云、主场云，店铺展示四大数字化工具助力降本增效</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <img src="../images/img-shu.png" alt="">
                            <p class="s1">树立品牌</p>
                            <p class="s2">多维度推广</p>
                            <p class="s3">平台自营宣发渠道，多种方式推广，提升企业知名度</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <img src="../images/img-xj.png" alt="">
                            <p class="s1">降低成本</p>
                            <p class="s2">集约化采购</p>
                            <p class="s3">享受平台集约化采购优惠价，实惠多多，福利多多</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <img src="../images/img-qc.png" alt="">
                            <p class="s1">增加收益</p>
                            <p class="s2">创新型增收</p>
                            <p class="s3">加入平台创新增收计划，稳定提升收益</p>
                        </div>
                    </li>
                </ul>
                <h4 class="title5" style="margin-top: 98px;margin-bottom: 20px;">尊享礼包</h4>
                <div class="libao-list">
                    <div>
                        <dl>
                            <dt class="dt1"><span>数字产品礼包</span></dt>
                            <dd>
                                <ul>
                                    <li><img src="../images/img-lb-1.png" alt=""><span>让管理更省心</span></li>
                                    <li><img src="../images/img-lb-2.png" alt=""><span>让设计更高效</span></li>
                                    <li><img src="../images/img-lb-3.png" alt=""><span>让发展更迅速</span></li>
                                </ul>

                                <p>具体内容请参看“<a href="#hyqy">会员权益</a>”</p>
                            </dd>
                        </dl>
                    </div>
                    <div>
                        <dl>
                            <dt class="dt2"><span>主场服务礼包</span></dt>
                            <dd>
                                <ul>
                                    <li><img src="../images/img-lb-4.png" alt=""><span>推荐搭建商机会</span></li>
                                    <li><img src="../images/img-lb-5.png" alt=""><span>保证金部分减免</span></li>
                                    <li><img src="../images/img-lb-6.png" alt=""><span>PLUS会员礼遇</span></li>
                                </ul>
                                <p class="p2">具体内容请参看“<a href="#hyqy">会员权益</a>”</p>
                            </dd>
                        </dl>
                    </div>
                    <div>
                        <dl>
                            <dt class="dt3"><span>实用资源礼包</span></dt>
                            <dd>
                                <ul>
                                    <li><img class="img2" src="../images/img-lb-7.png" alt=""><span>海量销售线索分享</span></li>
                                    <li><img class="img2" src="../images/img-lb-8.png" alt=""><span>优质工厂分享</span></li>
                                    <li><img class="img2" src="../images/img-lb-9.png" alt=""><span>展保云联券 x3</span></li>
                                    <li><img class="img2" src="../images/img-lb-10.png" alt=""><span>设计云下载劵 x60</span>
                                    </li>
                                </ul>
                                <p class="p2">具体内容请参看“<a href="#hyqy">会员权益</a>”</p>
                            </dd>
                        </dl>
                    </div>
                </div>
                <h4 class="title5" style="margin-top: 98px;margin-bottom: 20px;">我们的用户</h4>
            </section>
            <div style="background-color: #F9FAFB;">
                <ul class="logo-tab" id="logo-tab">
                    <!-- <li class="active">全部分类</li> -->
                    <li class="active">平台会员</li>
                    <li>产品用户</li>
                    <li>自营&合作展会</li>
                </ul>
                <section class="brand-list2-box" id="logo-list-box">
                    <ul class="brand-list2" id="logo-list">
                        <div class="logo1">
                            <li><img src="../images/logo/1神州.jpg" alt=""></li>
                            <li><img src="../images/logo/2飞鹰超华.jpg" alt=""></li>
                        </div>
                        <div class="logo1">
                            <li><img src="../images/logo/3联展.jpg" alt=""></li>
                            <li><img src="../images/logo/4道田.jpg" alt=""></li>
                        </div>
                        <div class="logo1">
                            <li><img src="../images/logo/5全荣.jpg" alt=""></li>
                            <li><img src="../images/logo/6石拓.jpg" alt=""></li>
                        </div>
                        <div class="logo1">
                            <li><img src="../images/logo/7伊鸣.jpg" alt=""></li>
                            <li><img src="../images/logo/8半分利.jpg" alt=""></li>
                        </div>
                        <div class="logo1">
                            <li><img src="../images/logo/9雅冠.jpg" alt=""></li>
                            <li><img src="../images/logo/10易构.jpg" alt=""></li>
                        </div>
                        <div class="logo1">
                            <li><img src="../images/logo/11同业圆通.jpg" alt=""></li>
                            <li><img src="../images/logo/12超越无限.jpg" alt=""></li>
                        </div>
                        <div class="logo1">
                            <li><img src="../images/logo/13冠恒.jpg" alt=""></li>
                            <li><img src="../images/logo/14君得.jpg" alt=""></li>
                        </div>
                        <div class="logo1">
                            <li><img src="../images/logo/15司创.jpg" alt=""></li>
                            <li><img src="../images/logo/16优秘.jpg" alt=""></li>
                        </div>
                        <div class="logo1">
                            <li><img src="../images/logo/17伊洛.jpg" alt=""></li>
                            <li><img src="../images/logo/18雅申.jpg" alt=""></li>
                        </div>
                        <div class="logo2">
                            <li><img src="../images/logo/19鼎尖.jpg" alt=""></li>
                            <li><img src="../images/logo/20汉展.jpg" alt=""></li>
                        </div>
                        <div class="logo2">
                            <li><img src="../images/logo/21红蝠.jpg" alt=""></li>
                            <li><img src="../images/logo/22优秘.jpg" alt=""></li>
                        </div>
                        <div class="logo2">
                            <li><img src="../images/logo/23澜扩.jpg" alt=""></li>
                            <li><img src="../images/logo/24美佳.jpg" alt=""></li>
                        </div>
                        <div class="logo2">
                            <li><img src="../images/logo/25墨创.jpg" alt=""></li>
                            <li><img src="../images/logo/26天府.jpg" alt=""></li>
                        </div>
                        <div class="logo2">
                            <li><img src="../images/logo/27中交联创.jpg" alt=""></li>
                            <li><img src="../images/logo/28武汉中博.jpg" alt=""></li>
                        </div>
                        <div class="logo2">
                            <li><img src="../images/logo/29东万华.jpg" alt=""></li>
                            <li><img src="../images/logo/30海南华章.jpg" alt=""></li>
                        </div>
                        <div class="logo2">
                            <li><img src="../images/logo/31展保云联.jpg" alt=""></li>
                            <li><img src="../images/logo/32政文.jpg" alt=""></li>
                        </div>
                        <div class="logo2">
                            <li><img src="../images/logo/33汇创.jpg" alt=""></li>
                            <li><img src="../images/logo/34优舍.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/35京兮.jpg" alt=""></li>
                            <li><img src="../images/logo/36中食.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/37饲料.jpg" alt=""></li>
                            <li><img src="../images/logo/38餐饮.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/39零售.jpg" alt=""></li>
                            <li><img src="../images/logo/40特许加盟.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/41集约化畜牧.jpg" alt=""></li>
                            <li><img src="../images/logo/42畜牧.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/43成都健身.jpg" alt=""></li>
                            <li><img src="../images/logo/44混凝土.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/45烘培.jpg" alt=""></li>
                            <li><img src="../images/logo/46成都广告.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/47成都幼教.jpg" alt=""></li>
                            <li><img src="../images/logo/48成都照明.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/49成都印刷.jpg" alt=""></li>
                            <li><img src="../images/logo/50成都环保.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/51生活用纸.jpg" alt=""></li>
                            <li><img src="../images/logo/52科学技术.jpg" alt=""></li>
                        </div>
                    </ul>
                </section>
            </div>

            <section id="jrfs" class="col" style="padding-top: 50px; padding-bottom: 50px;">
                <h4 class="title5" style="margin-top: 78px;margin-bottom: 36px;">加入方式</h4>
                <div class="div2 dlStyule">
                    <!-- <dl>
                        <dt class="dt1">普通会员</dt>
                        <dd>
                            <p>
                                <label for="">诚信保证金</label>
                                <span>
                                    <font class="font1">10万</font>元
                                </span>
                            </p>
                            <p>
                                <label for="">第三方系统服务费</label>
                                <span>
                                    <font class="font1">1800</font>元/年
                                </span>
                            </p>
                        </dd>
                    </dl> -->

                    <dl style="width: 100%;">
                        <dt class="dt2">VIP会员</dt>
                        <dd>
                            <p>
                                <label for="" style="width: 500px;">诚信保证金</label>
                                <span>
                                    <font class="font2">免收取</font>
                                </span>
                            </p>
                            <p>
                                <label for="" style="width: 500px;">平台服务费</label>
                                <span>
                                    <font class="font2">8800</font>元/年
                                </span>
                            </p>
                        </dd>
                    </dl>
                </div>
                <h4 id="hyqy" class="title5" style="margin-top: 78px;margin-bottom: 5px;">会员权益</h4>
                <p class="note" style="margin-top: 5px">市场参考价值超过<font>5万元</font>
                </p>

                <table align="center" class="table1" style="margin-top: 20px;">
                    <thead  align="middle" valign="center">
                        <tr>
                            <th style="vertical-align: middle">项目</th>
                            <th>内容</th>
                            <th>说明</th>
                            <th>VIP会员</th>
                            <!-- <th>普通会员</th> -->
                        </tr>
                    </thead>
                    <tbody  align="middle" valign="center">
                        <tr>
                            <td rowspan="2">展保云联劵</td>
                            <td>免费赠送</td>
                            <td>可兑换全国范围，不限展台面积，保额600万100万的展台保险(市场参考价值3000)</td>
                            <td>3张</td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td>专享渠道</td>
                            <td>可享受展保云联VIP价格购买全国展台安全保障服务</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td><img src="../images/icon-yes.svg" alt=""></td> -->
                        </tr>
                        <tr>
                            <td rowspan="4">平台资源</td>
                            <td>推荐搭建服务</td>
                            <td>vip会员 免收诚信保证金（推荐服务费5%）</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td><img src="../images/icon-yes.svg" alt=""></td> -->
                        </tr>
                        <!-- <tr>
                            <td>vip会员 免收诚信保证金（推荐服务费5%）</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                        </tr>-->
                        <tr> 
                            <td>现场VIP礼遇</td>
                            <td>平台自营&合作展会现场Plus礼遇</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td><img src="../images/icon-yes.svg" alt=""></td> -->
                        </tr>
                        <tr>
                            <td>物流优先</td>
                            <td>平台自运营展会物流优先服务（不违反主办方规定前提下）</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td>保证金优惠</td>
                            <td>平台自营&合作展会保证金优惠（单场展会10万封顶）</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td rowspan="2">行业推广</td>
                            <td>专享广告</td>
                            <td>设计云官网顶部banner广告位1个月发布权(市场参考价值1000元)</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td>软文推广</td>
                            <td>平台合作自媒体软文推广一次</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td rowspan="2">设计云</td>
                            <td>企业店铺</td>
                            <td>线上展装企业展示空间(市场参考价值3000元)</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td><img src="../images/icon-yes.svg" alt=""></td> -->
                        </tr>
                        <tr>
                            <td>图纸下载</td>
                            <td>全年赠送60套图纸免费下载(市场参考价值3000元)</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td rowspan="5">展装云</td>
                            <td>专业版</td>
                            <td>展装企业管理系统(市场参考价值5800元)</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td>行业资讯</td>
                            <td>掌握行业一手资讯</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td>展会排期</td>
                            <td>了解全国展会信息</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td>信息对接</td>
                            <td>搭建需求信息对接</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td>优质工厂</td>
                            <td>全国优质工厂资源</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <!-- <tr>
                            <td rowspan="2">主场云</td>
                            <td>基础版</td>
                            <td>主场业务系统工具(市场参考价值5800)</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                        </tr> -->
                        <!-- <tr>
                            <td>合作共赢计划</td>
                            <td>数字赋能主场增收</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                        </tr> -->

                    </tbody>
                </table>

                <h4 class="title5" style="margin-top: 88px; margin-bottom: 20px;">加入条件</h4>
                <div class="jrtj">
                    <div class="d1">
                        <div><img src="../images/img-jb.png" alt=""><span>申请企业注册资金 100 万以上</span></div>
                        <div><img src="../images/img-date.png" alt=""><span>企业成立年限3年以上</span></div>
                        <div><img src="../images/img-bz.png" alt=""><span>企业近 3 年无不良征信记录</span></div>
                    </div>
                    <div class="d2"><img src="../images/img-jz.png" alt=""><span>具有省级以上行业主管部门颁发的会展工程资质优先</span></div>
                </div>
                <p class="note">
                    <font>*仅限与本平台有以往合作历史的企业申请，名额有限，具体是否吸纳为会员以最终结果查询为准</font>
                </p>

                <h4 id="sqjr" class="title5" style="margin-top: 88px; margin-bottom: 20px;">申请加入</h4>
                <div>
                    <ul class="tab1 istab1">
                        <li class="tab-status-0 active xc-off">提交企业信息</li>
                        <li class="tab-status-1 xc-off">企业信息审核</li>
                        <li class="tab-status-2">加入VIP会员</li>
                        <li class="tab-status-3">申请审核</li>
                        <li class="tab-status-4">申请成功</li>
                    </ul>
                    <ul class="tab1 istab2">
                        <li class="tab-status-5 active xc-off">VIP会员续费审核</li>
                        <li class="tab-status-6 xc-off">VIP会员续费成功</li>
                    </ul>
                    <div style="margin-top: 20px;">
                        <div class="" id="box-status-0">
                            <ul class="qyxx">
                                <li>
                                    <div>企业信息</div>
                                </li>
                                <li>
                                    <div class="label">企业名称<font style="color: #e54c4a;">*</font></div>
                                    <div class="box"><input type="text" id="qyxx-company" maxlength="50"
                                            placeholder="请输入企业名称" autocomplete="new-password"></div>
                                </li>
                                <li>
                                    <div class="label">社会统一信用代码<font style="color: #e54c4a;">*</font></div>
                                    <div class="box"><input type="text" id="qyxx-pay_tax" maxlength="30"
                                            placeholder="请输入社会统一信用代码" autocomplete="new-password"></div>
                                </li>
                                <li>
                                    <div class="label">营业执照<font style="color: #e54c4a;">*</font></div>
                                    <div class="box">
                                        <input id="file-yyzz" type="file" accept="image/*,application/pdf"
                                            style="display:none">
                                        <a id="j-btn-yyzz" class="btn-up" href="javascript:;">上传营业执照</a>
                                        <span class="file-name" id="file-name-yyzz"></span>
                                    </div>
                                </li>
                                <li>
                                    <div class="label">资质文件</div>
                                    <div class="box">
                                        <input id="file-zxwj" type="file" accept="image/*,application/pdf"
                                            style="display:none">
                                        <a id="j-btn-zxwj" class="btn-up" href="javascript:;">上传资质文件</a>
                                        <span class="file-name" id="file-name-zxwj"></span>
                                        <span
                                            style="color: #999; font-size: 12px; margin-left: 15px;">省级以上行业主管部门颁发的会展工程资质</span>
                                    </div>
                                </li>
                            </ul>
                            <div style="text-align: center; margin-top: 25px;">
                                <a class="btn2" id="sub-qyxx" href="javascript:;">提交申请</a>
                            </div>
                        </div>
                        <div id="box-status-1" style="display: none;">
                            <div class="xxsh">
                                <div class="sh-status" id="j-status-1">
                                    <p class="s-status" style="margin-bottom: 20px;">
                                        <img src="../images/icon-wait.png" alt="">
                                        <span>企业信息正在审核中</span>
                                    </p>
                                </div>

                                <div class="sh-status" id="j-status-2">
                                    <p class="s-status" style="margin-bottom: 20px;">
                                        <img src="../images/icon-false.png" alt="">
                                        <span>企业信息审核被驳回</span>
                                    </p>
                                    <p class="bhyy">驳回原因：</p>
                                    <p class="" style="text-align: center;">
                                        <a id="j-cxsq" class="btn2" href="javascript:;">重新申请</a>
                                    </p>
                                </div>
                                <div class="p4">
                                    <p><label for="">企业名称：</label><span class="company"></span></p>
                                    <p><label for="">社会统一信用代码：</label><span class="pay_tax"></span></p>
                                </div>
                            </div>
                        </div>
                        <div id="box-status-2" style="display: none;">
                            <div class="sqrz" id="">
                                <div class="xc-off">
                                    <div class="s-status" style="margin-bottom: 20px;">
                                        <img src="../images/icon-true.png" alt="">
                                        <span>您提交的企业信息已通过审核</span>
                                    </div>
                                </div>
                                <div class="sqrz-con">
                                    <div class="top">
                                        <div><label for="">企业名称：</label><span class="company"></span></div>
                                        <div><label for="">社会统一信用代码：</label><span class="pay_tax"></span></div>
                                    </div>
                                    <div class="">
                                        <!-- <div class="item1">
                                            <div class="s-radio sqrz-type checked" value="2"><i></i><span>VIP会员</span>
                                            </div>
                                        </div> -->

                                        <div class="item2 sqrz-type-1">
                                            <div style="padding: 35px 0;">
                                                <div style="margin-bottom: 16px;">
                                                    <a class="btn"
                                                        href="../images/file/EXPOSCM平台普通会员服务协议.docx" download="EXPOSCM平台普通会员服务协议">下载入驻合同</a>
                                                    <span style="color: #E54C4A; margin-left: 10px;">*请加盖公章后回传合同</span>
                                                </div>
                                                <div class="s-flex-top">
                                                    <input type="file" accept="" id="ht-file" style="display: none;">
                                                    <a class="btn" id="ht-btn" href="javascript:;">回传入驻合同</a>
                                                    <ul class="ht-list" id="ht-list">
                                                        <!-- <li><span></span><i></i></li> -->
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <div class="item2 sqrz-type-2">
                                            <div style="padding: 35px 0;">
                                                <div class="item3">
                                                    <div class="name">主场云</div>
                                                    <label for="">公&ensp;司&ensp;&ensp;名&ensp;称：</label>
                                                    <div class="input-block company" style="border: none">
                                                    </div>
                                                </div>
                                                <div class="item3">
                                                    <div class="name"></div>
                                                    <label for="">管理员手机号：</label>
                                                    <div class="input-block">
                                                        <input class="input-item" id="per_phone" name="per_phone"
                                                            type="text" placeholder="请输入" autocomplete="new-password">
                                                        <p class="tip">*此手机号用于主场云系统超级管理员登录</p>
                                                    </div>
                                                </div>
                                                <div class="item3 input-box">
                                                    <div class="name"></div>
                                                    <label for="">验&emsp;&ensp;证&ensp;&emsp;码：</label>
                                                    <div class="item3 input-block">
                                                        <input class="input-item" id="per_verification_code"
                                                            name="per_verification_code" type="text" placeholder="请输入"
                                                            autocomplete="new-password">
                                                    </div>
                                                    <a class="btn code-btn" id="btn-per_verification_code"
                                                        href="javascript:;">获取验证码</a>
                                                </div>
                                            </div>
                                        </div> -->

                                        <div class="item2 sqrz-type-2">
                                            <div style="padding: 35px 0;">
                                                <div class="item3">
                                                    <div class="name">展装云</div>
                                                    <label for="">管理员账号名：</label>
                                                    <div class="input-block">
                                                        <input class="input-item" id="bc_name" name="bc_name"
                                                            type="text" placeholder="请输入" autocomplete="new-password">
                                                        <p class="tip">*此账号用于展装云系统超级管理员登录</p>
                                                    </div>
                                                </div>
                                                <div class="item3">
                                                    <div class="name"></div>
                                                    <label for="">设&ensp;置&ensp;&ensp;密&ensp;码：</label>
                                                    <div class="input-block">
                                                        <input class="input-item" id="bc_password" name="bc_password"
                                                            type="password" placeholder="请输入登录密码"
                                                            autocomplete="new-password">
                                                        <img class="icon-img j-eye" src="../images/eye-0.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="item2">
                                            <div style="padding: 35px 0;">
                                                <div class="item3">
                                                    <div class="name">设计云</div>
                                                    <label for="">店 铺 名 称：</label>
                                                    <div class="input-block company" style="border: none">
                                                    </div>
                                                </div>
                                                <div class="item3">
                                                    <div class="name"></div>
                                                    <label for="">登录手机号：</label>
                                                    <div class="input-block">
                                                        <input class="input-item" id="design_phone" name="design_phone"
                                                            type="text" placeholder="请输入" autocomplete="new-password">
                                                    </div>
                                                </div>
                                                <div class="item3 input-box">
                                                    <div class="name"></div>
                                                    <label for="">验&emsp;证&emsp;码：</label>
                                                    <div class="input-block">
                                                        <input class="input-item" id="design_verification_code"
                                                            name="design_verification_code" type="text"
                                                            placeholder="请输入" autocomplete="new-password">
                                                    </div>
                                                    <a class="btn code-btn" id="btn-design_verification_code"
                                                        href="javascript:;">获取验证码</a>
                                                </div>
                                                <div class="item3">
                                                    <div class="name"></div>
                                                    <label for="">设 置 密 码：</label>
                                                    <div class="input-block">
                                                        <input class="input-item" id="design_password"
                                                            name="design_password" type="password" placeholder="请输入登录密码"
                                                            autocomplete="new-password">
                                                        <img class="icon-img j-eye" src="../images/eye-0.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="sqrz-type-2 ">
                                    <div class="xy-box" style="margin-top: 20px;">
                                        <i class="s-checkbox" id="j-xieyi"></i>&ensp;
                                        <span>我已认真阅读并同意</span>
                                        <a class="" @click="showPdfPreview1" target="_blank"
                                            style="color: #5294F9;">《会展云平台VIP会员入驻协议》</a>
                                    </div>
                                </div>
                                <div style="text-align: center; margin-top: 30px;">
                                    <a id="sub-sqrz" class="btn2" href="javascript:;" style="width: 180px;">提交</a>
                                </div>
                            </div>
                        </div>
                        <div id="box-status-3" style="display: none;">
                            <div>
                                <div class="sh-status" id="j-status-4">
                                    <div class="s-status" style="margin-bottom: 20px;">
                                        <img src="../images/icon-wait.png" alt="">
                                        <span>入驻信息正在审核中</span>
                                    </div>
                                </div>
                                <div class="sh-status" id="j-status-5">
                                    <p class="s-status" style="margin-bottom: 20px;">
                                        <img src="../images/icon-false.png" alt="">
                                        <span>入驻申请被驳回</span>
                                    </p>
                                    <p class="bhyy">驳回原因：</p>
                                    <p class="" style="text-align: center;margin-bottom: 20px;">
                                        <a id="j-cxrz" class="btn2" href="javascript:;">重新加入</a>
                                    </p>
                                </div>
                                <div class="sqrz-con">
                                    <div class="top">
                                        <div><label for="">企业名称：</label><span class="company"></span></div>
                                        <div><label for="">社会统一信用代码：</label><span class="pay_tax"></span></div>
                                    </div>
                                    <div class="item4">
                                        <div class="item5">
                                            <div class="sqrz-type-1-x">
                                                <p style="margin-bottom: 15px;">方式一(普通会员)</p>
                                                <div class="s-flex-top">
                                                    <a class="btn j-ht" href="javascript:;">查看合同</a>
                                                    <a class="btn j-ht-up" href="javascript:;">上传合同</a>
                                                    <!-- image/*,application/pdf -->
                                                    <input id="ht-file-2" type="file" accept="" style="display:none">
                                                    <ul class="ht-list ht-list2" id="">
                                                        <!-- <li><span></span><i></i></li> -->
                                                    </ul>
                                                    <a class="btn j-ht-up-sub" href="javascript:;"
                                                        style="margin-left: 10px;">提交</a>
                                                </div>
                                            </div>
                                            <div class="sqrz-type-2-x">
                                                <p>VIP会员</p>
                                                <a class="" @click="showPdfPreview1" target="_blank"
                                                    style="color: #5294F9; margin-top: 15px; display: block;">《会展云平台VIP会员入驻协议》</a>
                                            </div>
                                        </div>
                                        <div class="item6">
                                            
                                            <!-- <div class="sqrz-type-2-x">
                                                <div class="item3">
                                                    <div class="name">主场云</div>
                                                    <label for="">公&ensp;司&emsp;名&ensp;称：</label>
                                                    <div class="input-block company" style="border: none;"></div>
                                                </div>
                                                <div class="item3">
                                                    <div class="name"></div>
                                                    <label for="">管理手机号名：</label>
                                                    <div class="input-block per_phone" style="border: none;"></div>
                                                </div>
                                            </div> -->
                                            <div class="sqrz-type-2-x" style="margin-top: 20px;">
                                                <div class="item3">
                                                    <div class="name">展装云</div>
                                                    <label for="">管理员账号名：</label>
                                                    <div class="input-block bc_name" style="border: none;"></div>
                                                </div>
                                            </div>
                                            <div style="margin-top: 20px;">
                                                <div class="item3">
                                                    <div class="name">设计云</div>
                                                    <label for="">店 铺 名 称：</label>
                                                    <div class="input-block company" style="border: none;"></div>
                                                </div>
                                                <div class="item3">
                                                    <div class="name"></div>
                                                    <label for="">登录手机号：</label>
                                                    <div class="input-block design_phone" style="border: none;"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bottom-box">
                                        <div class="bottom">
                                            <span class="s1">付款状态：</span>
                                            <div class="pay_status pay_status_all_0">
                                                <div class="s-flex">
                                                    <span class="s2">未到款</span>
                                                    <a class="btn btn-pay" href="javascript:;">去付款</a>
                                                </div>
                                            </div>
                                            <div class="pay_status pay_status_all_1">
                                                <span class="s1">已到款</span>
                                            </div>
                                            <div class="pay_status pay1_margin0">
                                                <p class="s1">第三方系统服务费已到款</p>
                                                <p class="s2">诚信保证金未到款，请将诚信保证金汇入合同</p>
                                            </div>
                                            <div class="pay_status pay0_margin1">
                                                <div class="s-flex">
                                                    <span class="s2">第三方系统服务费未到款</span>
                                                    <a class="btn btn-pay" href="javascript:;">去付款</a>
                                                </div>
                                                <span class="s1">诚信保证金已到款</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="box-status-4" style="display: none;">

                            <div class="sqrz-con">
                                <div class="top2">
                                    <div>
                                        <p><label class="s1" for="">企业名称：</label><span class="s2 company"></span></p>
                                        <p><label class="s1" for="">入驻时间：</label><span class="s2 create_time"></span>
                                        </p>
                                    </div>
                                    <div>

                                        <p><label class="s1" for="" style="color: #6c6c6c;">社会统一信用代码：</label><span class="s2 pay_tax"  style="color: #6c6c6c;"></span>
                                        </p>
                                        <p class="xfTime1"><label class="s1" for=""  style="color: #6c6c6c;">到&emsp; 期&emsp; 时 &emsp;间：</label><span
                                                class="s2 end_time"  style="color: #6c6c6c;"></span></p>
                                        <p class="xfTime2"><label class="s1" for=""  style="color: #6c6c6c;">续&emsp; 费&emsp; 时 &emsp;间：</label><span class="s2 create_time"  style="color: #6c6c6c;"></span></p>
                                    </div>
                                    <div class="xfTime2">
                                        <p style="opacity: 0;"><label class="s1" for="">企业名称：</label><span class="s2 company"></span></p>
                                        <p><label class="s1" for=""  style="color: #6c6c6c;">到&emsp; 期&emsp; 时 &emsp;间：</label><span
                                                class="s2 end_time" style="color: #6c6c6c;"></span></p>
                                    </div>
                                </div>
                                <div class="item4">
                                    <div class="item5">
                                        <div class="sqrz-type-1-x">
                                            <p style="margin-bottom: 15px;">方式一(普通会员)</p>
                                            <div class="s-flex-top">
                                                <a class="btn j-ht" href="javascript:;">查看合同</a>
                                                <a class="btn j-ht-up" href="javascript:;">上传合同</a>
                                                <ul class="ht-list ht-list2" id="">
                                                    <!-- <li><span></span><i></i></li> -->
                                                </ul>
                                                <a class="btn j-ht-up-sub" href="javascript:;"
                                                    style="margin-left: 10px;">提交</a>
                                            </div>
                                        </div>
                                        <div class="sqrz-type-2-x">
                                            <p>VIP会员</p>
                                            <a class="" @click="showPdfPreview1"
                                                style="color: #5294F9; margin-top: 15px; display: block;">《会展云平台VIP会员入驻协议》</a>
                                        </div>
                                    </div>
                                    <div class="item6 noSq">
                                        
                                        <!-- <div class="sqrz-type-2-x">
                                            <div class="item3">
                                                <div class="name">主场云</div>
                                                <label for="">公&ensp;司&emsp;名&ensp;称：</label>
                                                <div class="input-block company" style="border: none;"></div>
                                            </div>
                                            <div class="item3">
                                                <div class="name"></div>
                                                <label for="">管理手机号名：</label>
                                                <div class="input-block per_phone" style="border: none;"></div>
                                            </div>
                                        </div> -->
                                        <div class="sqrz-type-2-x" style="margin-top: 20px;">
                                            <div class="item3">
                                                <div class="name">展装云</div>
                                                <label for="">管理员账号名：</label>
                                                <div class="input-block bc_name" style="border: none;"></div>
                                            </div>
                                        </div>
                                        <div style="margin-top: 20px;">
                                            <div class="item3">
                                                <div class="name">设计云</div>
                                                <label for="">店 铺 名 称：</label>
                                                <div class="input-block company" style="border: none;"></div>
                                            </div>
                                            <div class="item3">
                                                <div class="name"></div>
                                                <label for="">登录手机号：</label>
                                                <div class="input-block design_phone" style="border: none;"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="yesSq" style="width:50%;height:200px; display: flex;flex-direction: column;justify-content: center;">
                                        <div>
                                            <img style="width: 20px; height: 20px;" src="../images/web1.png" alt="">
                                            <span>恭喜成为会展云平台VIP会员！您的专属会员客服恭候多时！</span>
                                        </div>
                                        <div style="display: flex;margin-top: 30px;">
                                            <img style="width: 95px; height: 95px;" src="../images/web3.png" alt="">
                                            <div style="margin-left: 20px;padding: 3px 0; font-size: 18px;color: #000;font-weight: 500;display: flex;flex-direction: column;justify-content: space-between;">
                                                <!-- <div>客服：曹洁</div> -->
                                                <!-- <div>电话：010-86460766-865</div> -->
                                                <div>邮箱：customerservice@exposaas.com</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="bottom-box">
                                    <div class="bottom">
                                        <span class="s1">付款状态：</span>
                                        <div class="pay_status pay_status_all_0"  id="pay_status_all_0">
                                            <div class="s-flex">
                                                <span class="s2">未到款</span>
                                                <a class="btn btn-pay" href="javascript:;">去付款</a>
                                            </div>
                                        </div>
                                        <div class="pay_status pay_status_all_1" id="pay_status_all_1">
                                            <span class="s1">已到款</span>
                                        </div>
                                        <div class="pay_status pay1_margin0">
                                            <p class="s1">第三方系统服务费已到款</p>
                                            <p class="s2">诚信保证金未到款，请将诚信保证金汇入合同</p>
                                        </div>
                                        <div class="pay_status pay0_margin1">
                                            <div class="s-flex">
                                                <span class="s2">第三方系统服务费未到款</span>
                                                <a class="btn btn-pay" href="javascript:;">去付款</a>
                                            </div>
                                            <span class="s1">诚信保证金已到款</span>
                                        </div>
                                    </div>
                                    <div class="bottom xfAlign">
                                        <span class="s1">开票状态：</span>
                                        <span class="s1 j-invoice-status">已申请</span>
                                        <span class="s1 j-invoice-status2" style="color:red">已冲红</span>
                                        <span class="s1 j-invoice-status3" style="color:red">已驳回</span>
                                        <span class="s1 j-invoice-status4">已开票</span>

                                        <a class="a1 j-invoice-get" href="javascript:;">申请发票</a>
                                        <span class="a1 j-invoice-down" style="cursor: pointer;" href="">下载发票</span>
                                        <a class="a1 j-invoice-detail" href="javascript:;">发票详情</a>
                                        <a class="a1 j-invoice-edit" href="javascript:;">修改发票信息</a>
                                        <a class="a1 j-invoice-edit2" href="javascript:;">重新申请</a>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                    <!-- 续费 -->
                    <div class="xf-box" id="j-xf">
                        <p id="xf-msg">您的会员还有10日即将到期</p>
                        <a id="btn-xf" class="btn2" href="javascript:;">会员续费</a>
                    </div>
                </div>
            </section>
        </div>
        <!-- <h4 id="lxwm" class="title5" style="margin-top: 70px; margin-bottom: 30px;">联系我们</h4>
        <div class="bg4">
            <div class="bg3">
                <div class="col box-lxwm">
                    <dl>
                        <dt>企微客服</dt>
                        <dt><img src="../images/111.jpg" alt=""></dt>
                        <dt>咨询热线</dt>
                        <dd>010-86460766-861</dd> -->
                        <!-- <dt>咨询邮箱</dt>
                        <dd>pangbo@exposaas.com</dd> -->
                    <!-- </dl>
                </div> 
            </div>
        </div>-->
        <!-- 尾部 -->
      <footers></footers>
      <!-- 右侧吸附客服咨询按钮 -->
      <contact></contact>
    </div>

    <!-- 付款 -->
    <div class="dialog-box" id="j-pay-dialog">
        <div class="dialog-bg">
            <div class="dialog">
                <div class="d-head">
                    <span class="d-title">订单付款</span>
                    <img class="d-close" src="../images/icon-no.svg" alt="">
                </div>
                <div class="d-con">
                    <div class="pay-con">
                        <div class="div1">
                            <div>
                                <p class="p1" style="border: none;font-size: 18px;margin-bottom: 20px;"><label for="">企&emsp;&ensp;业&emsp;名&emsp;&ensp;称：</label><span
                                        class="company" style="color: #000;"></span></p>
                                <p class="p1" style="border: none;font-size: 18px;margin-bottom: 20px; "><label for="">社会统一信用代码：</label><span class="pay_tax" style="color: #000;"></span></p>
                            </div>
                        </div>
                        <div class="p2 sqrz-type-1">方式一（普通会员）</div>
                        <div class="p2 sqrz-type-2 isvipxf">VIP会员</div>
                        <div class="p3">
                            <div class="s-radio pay-type checked" value="1" style="">
                                <i></i><span>线上付款</span></div>
                            <div class="s-radio pay-type" value="2"><i></i><span>线下付款</span></div>
                        </div>
                        <div class="pay-type-2">
                            <div class="p4">待付金额</div>
                            <table class="table1 sqrz-type-1">
                                <tr>
                                    <td>诚信保证金</td>
                                    <td class="td2 margin_free"></td>
                                </tr>
                                <tr>
                                    <td>第三方系统服务费</td>
                                    <td class="td2 pay_price"></td>
                                </tr>
                                <tr>
                                    <td class="td2" colspan="2">合计 <span class="margin_free_pay_price"></span></td>
                                </tr>
                            </table>
                            <table class="table1 sqrz-type-2">
                                <tr>
                                    <td>第三方系统服务费</td>
                                    <td class="td2 pay_price"></td>
                                </tr>
                            </table>
                            <div class="p4">对公账户</div>
                            <div class="div2">
                                <p>开户行：<span class="bank">招商银行北京分行华贸中心支行</span></p>
                                <p>户&emsp;名：<span class="company1">云融会展（上海）有限公司</span></p>
                                <p>帐&emsp;号：<span class="account">110926563210301</span></p>
                            </div>
                            <p class="p5">如已完成汇款，请等待后台审核</p>
                            <div style=" margin-top: 20px; text-align: center;">
                                <a id="btn-pay-sub" class="btn2" href="javascript:;">确定</a>
                            </div>
                        </div>
                        <div class="pay-type-1">
                            <div class="div3">
                                <span class="sqrz-type-1 pay_price"></span>
                                <span class="sqrz-type-2 pay_price"></span>
                                <div class="img1" id="pay-img"></div>
                                <p class="p6"><img src="../images/icon-wx.png" alt=""><span>微信扫码支付</span></p>
                                <!-- <p class="p5">请将诚信保证金汇入合同所显示的对公账户内</p> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 申请发票 -->
    <div class="dialog-box" id="j-invoice-dialog">
        <div class="dialog-bg">
            <div class="dialog">
                <div class="d-head">
                    <span class="d-title">申请发票</span>
                    <img class="d-close" src="../images/icon-no.svg" alt="">
                </div>
                <div class="d-con">
                    <form class="form-invoice" id="form-invoice">
                        <ul class="s-form">
                            <div class="p1">开票信息</div>
                            <!-- <li class="item">
                                <label for="">发票金额</label>
                                <input class="form-input input-pay_tax" type="text" maxlength="30"
                                    name="invoicePrice" style="border: none;" readonly="readonly">
                            </li> -->
                            <li class="item">
                                <label for="">发票类型</label>
                                <div class="s-radio invoice-radio checked" value="1" style="margin-right: 45px;">
                                    <i></i><span>增值税普通发票</span></div>
                                <div class="s-radio invoice-radio" value="2"><i></i><span>增值税专用发票</span></div>
                            </li>
                            <li class="item">
                                <label for="">发票抬头</label>
                                <!-- <div class="company"></div> -->
                                <input class="form-input input-company" type="text" maxlength="50"
                                    name="company_invoice_title" >
                            </li>
                            <li class="item">
                                <label for="">公司税号</label>
                                <!-- <div class="pay_tax"></div> -->
                                <input class="form-input input-pay_tax" type="text" maxlength="30"
                                    name="company_invoice_tax_number" >
                            </li>
                            <!-- <li class="item">
                                <label for="">开户银行</label>
                                <input class="form-input" type="text" maxlength="20" name="company_invoice_bank">
                            </li>
                            <li class="item">
                                <label for="">开户账号</label>
                                <input class="form-input" type="text" maxlength="30"
                                    name="company_invoice_bank_account">
                            </li>
                            <li class="item">
                                <label for="">注册地址</label>
                                <input class="form-input" type="text" maxlength="100" name="company_invoice_address">
                            </li>
                            <li class="item">
                                <label for="">注册电话</label>
                                <input class="form-input" type="text" name="company_invoice_phone">
                            </li> -->
                            <!-- <div class="p1 invoice-type-2" style="margin-top: 30px;">邮寄信息</div>
                            <li class="item invoice-type-2">
                                <label for="">所属地区</label>
                                <div class="form-input-block" data-toggle="distpicker" id="distpicker">
                                    <select class="form-input" name="province" ></select>
                                    <select class="form-input" name="city" ></select>
                                    <select class="form-input" name="district" ></select>
                                </div>
                            </li>
                            
                            <li class="item invoice-type-2">
                                <label for="">详细地址</label>
                                <input class="form-input" type="text" maxlength="100" name="mailing_address">
                            </li>
                            <li class="item invoice-type-2">
                                <label for="">联系人</label>
                                <input class="form-input" type="text" maxlength="20" name="mailing_username">
                            </li>
                            <li class="item invoice-type-2">
                                <label for="">联系电话</label>
                                <input class="form-input" type="text" name="mailing_phone">
                            </li> -->

                            <div class="p1 invoice-type-1" style="margin-top: 30px;">联系人</div>
                            <li class="item invoice-type-1">
                                <label for="">电子邮箱</label>
                                <input class="form-input" type="text" name="mailing_email">
                            </li>
                            <li class="item invoice-type-2">
                                <label for="">联系人</label>
                                <input class="form-input" type="text" maxlength="20" name="mailing_username">
                            </li>
                            <li class="item invoice-type-2">
                                <label for="">联系电话</label>
                                <input class="form-input" type="text" name="mailing_phone">
                            </li> 
                        </ul>
                        <div style="text-align: center;">
                            <a id="sub_apply_invoice" class="btn" href="javascript:;">提交</a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <!-- 申请详情 -->
    <div class="dialog-box" id="j-invoice-detail-dialog">
        <div class="dialog-bg">
            <div class="dialog">
                <div class="d-head">
                    <span class="d-title">开票详情</span>
                    <img class="d-close" src="../images/icon-no.svg" alt="">
                </div>
                <div class="d-con">
                    <div class="invoice-detail" id="invoice-detail">
                        <div style="display: flex;justify-content: space-between;">
                          <div class="status-bar">
                            <div class="icon">
                                <img src="../images/icon-true.png" alt="">
                                <div class="textCon">开票中</div>
                            </div>
                            <div class="line hideLine"></div>
                            <div class="icon hideIcon">
                                <img class="img2" src="../images/icon-true-2.png" alt="">
                                <img class="img1" src="../images/icon-true.png" alt="">
                                <div>已完成</div>
                            </div>
                        </div>
                        <el-button class="isBtnShow" type="primary" style="height: 40px;" @click="downFp">下载发票</el-button>
                        </div>
                        
                        <ul class="s-form">
                            <div class="p1">开票信息</div>
                            <li class="item">
                                <label for="">发票金额</label>
                                <div class="invoicePrice"></div>
                            </li>
                            <li class="item">
                                <label for="">发票类型</label>
                                <div class="invoice_type"></div>
                            </li>
                            <li class="item">
                                <label for="">发票抬头</label>
                                <div class="company_invoice_title"></div>
                            </li>
                            <li class="item">
                                <label for="">公司税号</label>
                                <div class="company_invoice_tax_number"></div>
                            </li>
                            <!-- <li class="item _j-type-2">
                                <label for="">开户银行</label>
                                <div class="company_invoice_bank"></div>
                            </li>
                            <li class="item _j-type-2">
                                <label for="">开户账号</label>
                                <div class="company_invoice_bank_account"></div>
                            </li>
                            <li class="item _j-type-2">
                                <label for="">注册地址</label>
                                <div class="company_invoice_address"></div>
                            </li>
                            <li class="item _j-type-2">
                                <label for="">注册电话</label>
                                <div class="company_invoice_phone"></div>
                            </li> -->
                            <li class="item">
                                <label for="">申请时间</label>
                                <div class="create_time"></div>
                            </li>
                            <!-- <div class="p1 j-type-2" style="margin-top: 30px;">邮寄信息</div>
                            <li class="item j-type-2">
                                <label for="">邮寄地址</label>
                                <div class="mailing_address"></div>
                            </li>
                            <li class="item j-type-2">
                                <label for="">联系人</label>
                                <div class="mailing_username"></div>
                            </li>
                            <li class="item j-type-2">
                                <label for="">联系电话</label>
                                <div class="mailing_phone"></div>
                            </li> -->
                            <div class="p1 j-type-1" style="margin-top: 30px;">联系人</div>
                            <li class="item j-type-1">
                                <label for="">电子邮箱</label>
                                <div class="mailing_email"></div>
                            </li>
                            <li class="item j-type-1">
                                <label for="">联系人</label>
                                <div class="company_invoice_contact"></div>
                            </li>
                            <li class="item j-type-1">
                                <label for="">联系电话</label>
                                <div class="company_invoice_phone"></div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 查看合同 -->
    <div class="dialog-box" id="j-ht-dialog">
        <div class="dialog-bg">
            <div class="dialog">
                <div class="d-head">
                    <span class="d-title">合同</span>
                    <img class="d-close" src="../images/icon-no.svg" alt="">
                </div>
                <div class="d-con">
                    <ul class="look-ht-list" id="look-ht-list">
                        <!-- <li><a href="" target="_blank"></a></li> -->
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
    <script>
    import headers from '@/components/Header';
    import footers from '@/components/Footer';
    import contact from '@/components/contact';
    import activity from  '@/components/activity.js';
    import common from  '@/components/common.js';
    import '@/components/distpicker';
    export default {
        name:'activity',
        mixins:[activity,common],
        components: {
            headers,
            footers,
            contact,
        },
        computed: {},
        mounted(){
        },
        methods:{
            showPdfPreview1(){
                window.open('https://www.exposcm.com/member.pdf')
            },
        }
    }
</script>
<style scoped>
.dlStyule {
    justify-content: center;
}
.dlStyule>dl {
    flex: unset !important;
    
}
.table1 th {
    vertical-align: middle;
}
.table1 td {
    vertical-align: middle;
}
.p1 {
    border: none;
    padding-top: 0;
    padding-bottom: 0;
}
body {
  min-width: 1440px;
  font-size: 16px;
  background-color: #fff;
}
.main {
  /* min-width: 1440px; */
  background-color: #fff;
}
.s-flex {
  display: flex;
  align-items: center;
}
.s-flex-top {
  display: flex;
  align-items: flex-start;
}
.title1 {
  font-size: 58px;
  line-height: 70px;
  font-weight: 400;
}
.title2 {
  font-size: 42px;
  line-height: 65px;
  font-weight: 400;
}
.title3 {
  font-size: 34px;
  text-align: center;
  font-weight: 400;
}
.title4 {
  font-size: 24px;
  /* line-height: 75px; */
}
.title5 {
  font-size: 30px;
  text-align: center;
  font-weight: 400;
}
.txt1 {
  font-size: 16px;
  line-height: 30px;
  color: #454545;
}
.ban-bg {
  height: 100vh;
  width: 100%;
  min-width: 1266px;
  /* background: url(../images/bg1.jpg) center; */
  /* background-size: cover; */
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
}
.index-main .ban-bg {
  background: url(../images/bg1.jpg) center;
  background-size: cover;
}
.solution-main .ban-bg {
  background: url(../images/bg2.jpg) center;
  background-size: cover;
}
.news-main .ban-bg {
  background: url(../images/bg3.jpg) center;
  background-size: cover;
}
.contact-main .ban-bg {
  background: url(../images/bg4.jpg) center;
  background-size: cover;
}
.row {
  background-color: #fff;
}
.col {
  width: 1266px;
  margin: 0 auto;
}
.col-l {
  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  padding-left: 150px;
  padding-right: 150px;
  background-color: #fff;
}
.col-r {
  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  background-color: #fff;
}
.ban {
  height: calc(100vw / 1920 * 563);
  /* margin-top: 80px; */
  min-height: 400px;
  background-color: rgba(0, 0, 0, 0.4);
}
.ban .col {
  /* text-align: center; */
  height: 100%;
  display: flex;
  align-items: center;
}
.ban .col .title1 {
  color: #fff;
  text-align: center;
  width: 100%;
}
.index-main .ban {
  background: url(../images/ban-1.jpg) center;
  background-size: cover;
  height: calc(100vw / 1920 * 698 + 80px);
}
.index-main .ban .h1 {
  font-size: 50px;
  line-height: 90px;
  color: #07B6FF;
  font-weight: 500;
  text-align: left;
}
.index-main .ban .btn {
  display: block;
  width: 150px;
  height: 47px;
  background-color: #007CE6;
  font-size: 14px;
  color: #fff;
  line-height: 47px;
  text-align: center;
  margin-top: 35px;
}
.index-main .ban .line {
  margin-top: 50px;
  width: 275px;
  height: 3px;
  background: linear-gradient(270deg, #4FCEFF 0%, #08B6FF 100%);
}
.head-box {
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  transition: background-color 0.6s;
}
.header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  /* justify-content: ; */
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  height: 80px;
}
.logo img {
  width: 103px;
}
.logo img.logo-1 {
  display: none;
}
.header-r {
  display: flex;
  align-items: center;
}
.header-r .login {
  height: 80px;
  margin-left: 50px;
  position: relative;
}
.header-r .login .a1 {
  line-height: 80px;
  color: #303133;
  font-size: 18px;
}
.header-r .login .user-op {
  position: absolute;
  top: 80px;
  right: 0;
  width: 100px;
  display: none;
  background: #fff;
  padding: 15px 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.header-r .login .user-op li {
  padding: 10px 15px;
  text-align: center;
  cursor: pointer;
}
.header-r .login .user-op li:hover {
  background-color: #f6f6f6;
}
.nav {
  display: flex;
}
.nav > li {
  position: relative;
}
.nav > li + li {
  margin-left: 50px;
}
.nav > li > a {
  display: block;
  font-size: 18px;
  color: #303133;
  line-height: 80px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
}
.nav > li:hover > a,
.nav > li.active > a {
  /* font-weight: bold; */
  color: #007CE6;
}
.nav > li .menu-group {
  transition: all 0.4s;
  height: 0;
  width: auto;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  padding: 5px 0;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}
.nav > li .menu-group .menu-item {
  display: block;
  padding: 8px 20px;
  white-space: nowrap;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.nav > li .menu-group .menu-item.active,
.nav > li .menu-group .menu-item:hover {
  color: #007CE6;
}
.nav > li:hover .menu-group {
  height: auto;
  opacity: 1;
}
.list1 {
  display: flex;
  justify-content: space-between;
}
.list1 dl {
  display: inline-block;
}
.list1 dt {
  font-size: 80px;
  font-weight: 600;
  position: relative;
}
.list1 dt span {
  position: absolute;
  font-size: 50px;
  font-weight: 700;
  right: -32px;
  top: -4px;
}
.list1 dd {
  font-size: 20px;
  margin-top: 10px;
  font-weight: 600;
}
.list2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.list2 li {
  /* height: 273px; */
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  position: relative;
}
.list2 li img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}
.list2 li:not(:first-child) {
  margin-left: 40px;
}
.list2 li a {
  display: block;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
}
.list2 li a span {
  color: #fff;
  font-size: 26px;
  position: relative;
}
.list2 li a span:after {
  content: '';
  display: block;
  width: 35px;
  border-top: 2px solid #fff;
  position: absolute;
  bottom: -15px;
}
.list-jjfa {
  overflow: hidden;
  width: calc(100% + 40px);
  margin-bottom: -40px;
}
.list-jjfa a {
  display: block;
  width: calc(50% - 40px);
  float: left;
  margin-right: 40px;
  margin-bottom: 40px;
  position: relative;
}
.list-jjfa a img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.list-jjfa a div {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 40px;
}
.list-jjfa a div p {
  font-size: 30px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 30px;
  margin-bottom: 20px;
}
.list-jjfa a div span {
  width: 62px;
  font-size: 12px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 18px;
}
.box-hzst {
  display: flex;
}
.box-hzst .div-l {
  margin-right: 40px;
  flex: 1;
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.box-hzst .div-l p {
  font-size: 18px;
  color: #303133;
  line-height: 54px;
}
.box-hzst .div-l a {
  display: block;
  width: 190px;
  height: 58px;
  border-radius: 2px;
  line-height: 58px;
  text-align: center;
  font-size: 16px;
  margin-top: 100px;
  background-color: #5294F9;
  color: #fff;
}
.box-hzst .div-r {
  flex: 1;
}
.box-hzst .div-r img {
  width: 100%;
}
.box-4 {
  position: relative;
  overflow: hidden;
}
.ban2-list {
  position: relative;
}
.ban2-list li {
  position: absolute;
  opacity: 0;
  transition: all 1s;
}
.ban2-list li img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.ban2-box {
  float: right;
  width: 50%;
}
.box-4-con {
  float: left;
  width: 50%;
  padding-right: 50px;
}
.box-4-con img {
  width: 166px;
}
.box-4-con .p1 {
  font-size: 22px;
  font-weight: 500;
  margin-top: 50px;
  margin-bottom: 14px;
}
.box-4-con .span1 {
  font-size: 20px;
  font-weight: 300;
  color: #606266;
  line-height: 34px;
}
.box-4-con .a1 {
  display: block;
  width: 190px;
  height: 58px;
  border-radius: 2px;
  line-height: 58px;
  text-align: center;
  font-size: 16px;
  margin-top: 100px;
  background-color: #5294F9;
  color: #fff;
}
.btn-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 30px;
}
.btn-box a {
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  border: 1px solid #a1a1a1;
  position: relative;
}
.btn-box a:last-child {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}
.btn-box a::before {
  content: '';
  display: block;
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  border-right: 12px solid #a1a1a1;
  border-bottom: 9px solid transparent;
  position: absolute;
  top: 16px;
  left: 18px;
}
.btn-box a::after {
  content: '';
  display: block;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-right: 9px solid #fff;
  border-bottom: 7px solid transparent;
  position: absolute;
  top: 18px;
  left: 20px;
}
.btn-box span {
  margin: 0 15px;
  font-size: 14px;
}
.box-2 {
  position: relative;
}
.box-2-bg {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 0;
  top: 0;
  left: 0;
}
.box-2-bg .bg-top {
  position: absolute;
  width: 100%;
  height: 90px;
  background-color: rgba(0, 0, 0, 0.4);
}
.box-2-bg .bg-bottom {
  position: absolute;
  width: 100%;
  top: 90px;
  bottom: 0;
  background-color: #fff;
}
.box-2-con {
  padding-top: 90px;
  padding-bottom: 90px;
  position: relative;
  z-index: 2;
}
.line1 {
  width: 35px;
  border-top: 5px solid #000;
  margin-bottom: 30px;
}
.box-3,
.box-4 {
  padding-top: 50px;
  padding-bottom: 50px;
}
.box-3 .list2 {
  margin-top: 50px;
}
.box-5-item .new-title {
  font-size: 24px;
  font-weight: 500;
  color: #303133;
  line-height: 42px;
}
.box-5-item:nth-child(2n) {
  background: url(../images/bg11.jpg) center;
  background-size: cover;
  /* background-color: rgba(0, 0, 0, .4); */
  color: #fff;
  position: relative;
}
.box-5-item:nth-child(2n) .new-title {
  color: #fff;
}
.box-5-item:nth-child(2n):before {
  content: '';
  display: block;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 0;
}
.box-5-con {
  width: 1266px;
  /* padding-left: 135px; */
  padding: 50px 0 50px 135px;
  position: relative;
  z-index: 2;
}
.time1 {
  width: 144px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  font-size: 14px;
  background-color: #000;
  color: #fff;
  margin-bottom: 20px;
}
.box-5-item:nth-child(2n) .time1 {
  background-color: #fff;
  color: #222;
}
.box-5-item:nth-child(2n) .txt1 {
  color: #fff;
}
.footer {
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  padding: 40px 0;
}
.footer .link-list {
  display: flex;
}
.footer .link-list dl dt {
  margin-right: 100px;
  font-size: 16px;
  /* font-family: PingFangSC-Medium, PingFang SC; */
  font-weight: 500;
  color: #303133;
  line-height: 22px;
  height: 32px;
  position: relative;
}
.footer .link-list dl dt:after {
  content: '';
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #0071FF;
  transition: all 0.4s;
}
.footer .link-list dl:hover dt:after {
  width: 30px;
}
.footer .link-list dl dd {
  font-size: 14px;
  margin-top: 15px;
}
.footer .link-list dl dd a {
  color: #606266;
  line-height: 20px;
}
.footer .link-list dl dd a:hover {
  color: #0071FF;
}
.footer .footer-r {
  display: flex;
}
.footer .footer-r > img {
  width: 155px;
  height: 155px;
  margin-right: 15px;
}
.footer .footer-r > div {
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.footer .footer-r > div dt {
  font-size: 18px;
  color: #303133;
  line-height: 18px;
  margin-bottom: 6px;
}
.footer .footer-r > div dd {
  color: #303133;
  font-size: 14px;
  line-height: 20px;
}
.icpn {
  border-top: 1px solid #EBEEF5;
  padding: 10px 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #909399;
  line-height: 17px;
}
.solution-main .ban {
  background: url(../images/ban-3.png) center;
  background-size: cover;
}
.solution-main .ban .title1 {
  color: #fff;
  text-align: left;
  width: 100%;
}
.solution-main .ban p {
  color: #fff;
  font-size: 30px;
  margin-top: 20px;
  font-weight: 300;
}
.solution-main .ban2 {
  background: url(../images/ban-4.png) center;
  background-size: cover;
}
.solution-main .ban3 {
  background: url(../images/ban-5.png) center;
  background-size: cover;
}
.solution-main .ban4 {
  background: url(../images/ban-6.png) center;
  background-size: cover;
}
.solution-main .list1 {
  text-align: center;
}
.paas-main .ban {
  background: url(../images/ban-9.png) center;
  background-size: cover;
}
.paas-main-2 .ban {
  background: url(../images/ban-7.png) center;
  background-size: cover;
}
.paas-main-3 .ban {
  background: url(../images/ban-10.png) center;
  background-size: cover;
}
.paas-main-3 .t1 {
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #303133;
  line-height: 50px;
}
.paas-main-3 .p1 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  line-height: 28px;
}
.list-hxys {
  display: flex;
}
.list-hxys dl {
  border: 1px solid #DDDDDD;
  border-radius: 4px;
  flex: 1;
  padding: 50px;
}
.list-hxys dl dt {
  height: 42px;
  font-size: 30px;
  font-weight: 600;
  color: #303133;
  line-height: 42px;
  text-align: center;
}
.list-hxys dl dd {
  font-size: 20px;
  font-weight: 400;
  color: #303133;
  line-height: 28px;
  text-align: center;
  margin-top: 30px;
}
.list-hxys dl + dl {
  margin-left: 50px;
}
.txt2 {
  font-size: 20px;
  color: #737373;
  line-height: 50px;
  text-align: center;
}
.list3 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: stretch;
}
.list3 a {
  flex: 510;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.list3 a.li2 {
  margin-left: -5.3%;
}
.list3 a.li2 > div {
  width: 80.5%;
  top: 0;
}
.list3 a.li2 > .d2 {
  width: 75%;
}
.list3 a:first-child,
.list3 a:last-child {
  flex: 394;
}
.list3 a img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.list3 a .img1 {
  display: none;
  opacity: 0;
}
.list3 a .img2 {
  display: block;
  opacity: 1;
}
.list3 a > div {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
}
.list3 a > div div {
  position: relative;
  font-size: 24px;
  color: #FFFFFF;
  line-height: 66px;
  margin-left: 25px;
  padding-left: 10px;
}
.list3 a > div div::after {
  content: '';
  display: block;
  width: 0;
  height: 24px;
  border-left: 5px solid #5294F9;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -12px;
}
.list3 a > div p {
  font-size: 20px;
  line-height: 35px;
  text-align: center;
}
.list3 a:hover .img1 {
  display: block;
  opacity: 1;
}
.list3 a:hover .img2 {
  display: none;
  opacity: 0;
}
.list5 {
  height: 490px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.list5 li {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 100%;
  position: relative;
}
.list5 li img {
  display: block;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}
.list5 li > div {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition-duration: 1s;
}
.list5 li > div div {
  position: relative;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 66px;
  margin-left: 25px;
  padding-left: 10px;
}
/* .list5 li > div div::after {
  content: '';
  display: block;
  width: 100px;
  height: 3px;
  background-color: rgba(255, 255, 255, 0.8);
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -45px;
} */
.list5 li > div p {
  font-size: 16px;
  line-height: 35px;
  text-align: center;
  margin-top: 40px;
}
.list5 li:hover > div {
  background-color: #000000;
  color: #ffffff;
}
.list5 li:hover > div div::after {
  border-color: #ffffff;
}
.list6 {
  display: flex;
}
.list6 li {
  flex: 1;
}
.list6 li + li {
  margin-left: 13px;
}
.list6 img {
  width: 100%;
}
.list6 div {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #303133;
  line-height: 54px;
  text-align: center;
}
.list7 {
  display: flex;
}
.list7 li {
  flex: 1;
}
.list7 li + li {
  margin-left: 44px;
}
.list7 li div {
  position: relative;
}
.list7 li div img {
  width: 100%;
}
.list7 li div p {
  position: absolute;
  bottom: 0;
  left: 0;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  height: 94px;
  line-height: 54px;
  font-size: 20px;
  text-align: center;
  padding-top: 24px;
  width: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
}
.list7 li a {
  display: block;
  height: 30px;
  border-radius: 2px;
  border: 1px solid #5294F9;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0065FF;
  line-height: 30px;
  text-align: center;
  margin-top: 16px;
}
.list7 li:hover a,
.list7 li.active a {
  background: #0065FF;
  color: #fff;
}
.list8 {
  display: flex;
  justify-content: space-between;
}
.list8 li {
  text-align: center;
}
.list8 li img {
  width: 80px;
  height: 80px;
}
.list8 li p {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  margin-top: 20px;
}
.col-r-2 {
  width: calc(1266px + (100% - 1266px) / 2);
  margin-left: calc((100% - 1266px) / 2);
}
.list4 {
  height: 340px;
  /* overflow: hidden; */
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.list4 li {
  height: 340px;
  width: 570px;
  /* float: left; */
  background-color: #fff;
  border-radius: 4px;
  padding: 70px 50px;
}
.list4 li + li {
  margin-left: 50px;
}
.list4 .i-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 40px;
}
.list4 .i-title img {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}
.list4 .i-title span {
  font-size: 28px;
}
.list4 p {
  font-size: 20px;
  line-height: 30px;
  color: #737373;
}
.list-btn {
  margin-top: 40px;
}
.list-btn a {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  /* background: #464646; */
  margin-right: 15px;
  border: 2px solid #464646;
}
.list-btn a.active {
  background: #464646;
}
.brand-list {
  overflow: hidden;
  margin-bottom: -40px;
}
.brand-list li {
  width: calc((100% - 200px) / 6);
  height: 95px;
  background-color: #fff;
  text-align: center;
  float: left;
  margin-right: 40px;
  margin-bottom: 40px;
  border: 1px solid #F4F6F8;
}
.brand-list li:nth-child(6n) {
  margin-right: 0;
}
.brand-list li img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.logo-tab {
  display: flex;
  justify-content: center;
  padding: 30px;
}
.logo-tab li {
  width: 180px;
  height: 50px;
  border-radius: 4px;
  text-align: center;
  line-height: 50px;
  color: #303133;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  cursor: pointer;
}
.logo-tab li.active {
  background: #5294F9;
  color: #fff;
}
.brand-list2-box {
  padding: 0 20px 60px;
  overflow: hidden;
}
.brand-list2 {
  overflow: hidden;
  margin-right: -20px;
  margin-bottom: -20px;
  display: flex;
}
.brand-list2 li {
  width: 200px;
  height: 90px;
  background-color: #fff;
  text-align: center;
  margin-right: 20px;
  margin-bottom: 20px;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid #F4F6F8;
}
.brand-list2 li img {
  height: 100%;
}
/* 企业动态 */
.news-main {
  /* .ban-bg{
        background: url(../images/bg3.jpg) center;
        background-size: cover;
    } */
}
.news-con {
  display: flex;
  padding-top: 50px;
}
.news-l {
  flex: 1;
  width: 0;
}
.news-r {
  width: 400px;
  margin-left: 100px;
}
.news-tab {
  display: flex;
  border-bottom: 1px solid #DCDFE6;
}
.news-tab a {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #606266;
  line-height: 25px;
  padding: 10px 20px;
  margin-right: 50px;
  position: relative;
}
.news-tab a::after {
  content: '';
  display: block;
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 0%;
  height: 2px;
  background: #5294F9;
  transform: translateX(-50%);
  transition: all 0.4s;
}
.news-tab a:hover,
.news-tab a.active {
  color: #5294F9;
}
.news-tab a:hover::after,
.news-tab a.active::after {
  width: 100%;
}
.news-list {
  padding-top: 20px;
  padding-bottom: 20px;
}
.news-list li.item {
  display: flex;
  padding: 30px 0;
}
.news-list li.item .i-left {
  width: 187px;
  margin-right: 25px;
}
.news-list li.item .i-left .i-time {
  width: 187px;
  height: 42px;
  text-align: center;
  line-height: 42px;
  background-color: #5294F9;
  color: #fff;
  font-size: 16px;
}
.news-list li.item .i-right {
  flex: 1;
}
.news-list li.item .i-right .i-title {
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #343537;
  line-height: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.news-list li.item .i-right .i-txt {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #909399;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.news-t {
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #343537;
  line-height: 25px;
  margin-bottom: 15px;
}
.news-list2 li {
  display: flex;
  padding: 20px 0 10px;
  border-bottom: 1px solid #F0F2F5;
}
.news-list2 li label {
  margin-right: 20px;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  background-color: #C0C4CC;
  color: #fff;
  font-size: 16px;
}
.news-list2 li label.active {
  background-color: #5294F9;
}
.news-list2 li > div {
  flex: 1;
  width: 0;
}
.news-list2 li > div a {
  display: block;
  font-size: 18px;
  font-weight: 600;
  color: #343537;
  line-height: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.news-list2 li > div span {
  font-size: 12px;
  font-weight: 400;
  color: #343537;
  line-height: 17px;
}
.news-code {
  display: flex;
  align-items: center;
  margin-top: 70px;
}
.news-code img {
  width: 110px;
  height: 110px;
  margin-right: 16px;
}
.news-code div p {
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #343537;
  line-height: 25px;
  margin-bottom: 8px;
}
.news-code div span {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #343537;
  line-height: 17px;
}
.link-bar {
  margin-bottom: 30px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #343537;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.link-bar a {
  color: #5294F9;
}
.new-detail .new-title {
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #343537;
  line-height: 40px;
}
.new-detail ._msg {
  margin-top: 12px;
  margin-bottom: 32px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #909399;
  line-height: 20px;
}
.new-detail ._msg span {
  margin-right: 20px;
}
.new-detail ._content {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #343537;
  line-height: 34px;
  hyphens: auto;
  overflow-wrap: break-word;
}
.new-detail ._p {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
.new-detail ._p a {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #909399;
  line-height: 20px;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 联系我们 */
.contact-main {
  /* .ban-bg{
        background: url(../images/bg3.jpg) center;
        background-size: cover;
    } */
}
.contact-list {
  padding-top: 50px;
  padding-bottom: 50px;
}
.contact-list li {
  display: flex;
  align-items: center;
}
.contact-list li + li {
  margin-top: 45px;
}
.contact-list li .i-left {
  width: 100px;
  margin-right: 70px;
}
.contact-list li .i-left img {
  width: 100%;
}
.contact-list li .i-right {
  flex: 1;
}
.contact-list li .i-right .i-title {
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 20px;
  font-weight: 500;
  font-family: PingFangSC-Medium, PingFang SC;
}
.contact-list li .i-right .i-txt {
  font-size: 16px;
  color: #303133;
  line-height: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.about-nav-box {
  position: fixed;
  z-index: 10;
  width: 100%;
  top: 80px;
  left: 0;
  background: #fff;
  padding-top: 20px;
}
.about-nav {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #F5F7FA;
}
.about-nav a {
  font-size: 18px;
  color: #303133;
  line-height: 25px;
  height: 30px;
  position: relative;
}
.about-nav a::after {
  content: '';
  display: block;
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 0%;
  height: 2px;
  background: #5294F9;
  transform: translateX(-50%);
  transition: all 0.4s;
}
.about-nav a:hover,
.about-nav a.active {
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.about-nav a:hover::after,
.about-nav a.active::after {
  width: 100%;
}
.bg-map {
  background: url(../images/bg-map2.png) center no-repeat;
  background-size: contain;
}
.bg-map2 {
  background: url(../images/bg-map.png) center no-repeat;
  background-size: contain;
}
.bg-line {
  background: url(../images/bg-line.png) center no-repeat;
  background-size: contain;
}
.qyyj {
  display: flex;
  align-items: center;
}
.qyyj .btn-prev,
.qyyj .btn-next {
  cursor: pointer;
  width: 50px;
  height: 50px;
}
.qyyj .btn-prev {
  background: url(../images/icon-prev.png) center no-repeat;
  background-size: 20px ;
}
.qyyj .btn-next {
  background: url(../images/icon-next.png) center no-repeat;
  background-size: 20px ;
}
.qyyj > ul {
  flex: 1;
  height: 333px;
  perspective: 1000px;
  margin-left: 100px;
  margin-right: 100px;
}
.qyyj > ul li {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  border: 1px solid #C0C4CC;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.8s;
  opacity: 0;
  user-select: none;
  background: rgba(255, 255, 255, 0.1);
}
.qyyj > ul li p {
  font-size: 16px;
  color: #303133;
  transition: all 0.8s;
}
.qyyj > ul li span {
  font-size: 12px;
  color: #303133;
  line-height: 16px;
  text-align: center;
  display: none;
  overflow: hidden;
  transform: scale(0);
  margin-top: 6px;
  transition: all 0.8s;
}
.qyyj > ul .cur-img {
  transform: translate(-50%, -50%) scale(2.08125);
  z-index: 100;
  opacity: 1;
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 0px 0px 13px 0px rgba(22, 65, 131, 0.33);
  border: 1px solid #98B9EC;
}
.qyyj > ul .cur-img p {
  color: #5294F9;
  font-size: 12px;
}
.qyyj > ul .cur-img span {
  display: block;
  transform: scale(1);
}
.qyyj > ul .pre-img {
  left: 0;
  transform: translate(0, -50%) scale(1);
  z-index: 9;
  opacity: 0.9;
}
.qyyj > ul .next-img {
  left: 100%;
  transform: translate(-100%, -50%) scale(1);
  z-index: 9;
  opacity: 0.9;
}
.list9 {
  display: flex;
  flex-wrap: wrap;
}
.list9 li {
  margin: 30px;
  width: calc(50% - 60px);
}
.list9 li img {
  width: 100%;
  display: block;
}
.list9 li p {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  line-height: 25px;
  margin-top: 12px;
  overflow: hidden;
}
.fzlc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 100px;
}
.fzlc span {
  cursor: pointer;
  font-size: 21px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #303133;
  line-height: 29px;
}
.fzlc span.active {
  color: #0065FF;
  font-size: 26px;
}
.fzlc-msg {
  width: 762px;
  height: 198px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 2px 8px 0px rgba(0, 94, 201, 0.07);
  border-radius: 2px;
  border: 1px solid #EBF3FC;
  margin: 50px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fzlc-msg div {
  font-size: 21px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #303133;
  line-height: 29px;
}
.fzlc-msg p {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  line-height: 26px;
  margin-top: 10px;
}
.ptry img {
  display: block;
  width: 1028px;
  margin: 25px auto;
}
.list10 {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.list10 li {
  width: 330px;
  margin: 50px 90px;
  text-align: center;
}
.list10 li img {
  width: 100%;
  display: block;
}
.list10 li div {
  text-align: center;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #303133;
  line-height: 33px;
  margin-top: 25px;
  margin-bottom: 6px;
}
.list10 li span {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #303133;
  line-height: 25px;
}
.list10 li p {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  line-height: 31px;
  margin-top: 6px;
}
.list11 {
  display: flex;
  justify-content: center;
  margin-top: 25px;
}
.list11 div {
  border: 1px solid #DCDFE6;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px;
  width: 309px;
}
.list11 div + div {
  margin-left: 40px;
}
.list11 div p {
  font-size: 21px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #303133;
  line-height: 29px;
  margin-bottom: 30px;
}
.list11 div img {
  width: 176px;
  height: 176px;
}
.list11 div span {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #303133;
  line-height: 25px;
  margin-top: 5px;
}
.list12 {
  width: 1007px;
  padding-bottom: 40px;
  background: #FFFFFF;
  border: 1px solid #DCDFE6;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  margin-top: 40px;
}
.list12 dl {
  padding: 40px 50px 0;
}
.list12 dl dt {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #303133;
  line-height: 25px;
  margin-bottom: 15px;
}
.list12 dl dd {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  line-height: 20px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.list12 dl dd img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}
.list12 .dl1 {
  flex-grow: 1;
}
.list12 .dl2 {
  width: 400px;
}
/* 合作生态 */
.cooperation-main .ban {
  background: url(../images/ban-2.png) no-repeat;
  background-size: cover;
}
.cooperation-main .div1 {
  display: flex;
  align-items: center;
}
.cooperation-main .div1 > div {
  width: calc(50% - 100px);
}
.cooperation-main .div1 > div .p1 {
  font-size: 30px;
  font-weight: 600;
  color: #5294F9;
  line-height: 42px;
}
.cooperation-main .div1 > div .p2 {
  font-size: 20px;
  font-weight: 400;
  color: #303133;
  line-height: 28px;
  margin-bottom: 30px;
}
.cooperation-main .div1 > div .p3 {
  font-size: 30px;
  font-weight: 600;
  color: #6BC73C;
  line-height: 42px;
}
.cooperation-main .div1 > img {
  width: calc(50% + 100px);
}
.cooperation-main .div2 {
  display: flex;
  justify-content: space-between;
}
.cooperation-main .div2 div p {
  color: #303133;
  font-size: 16px;
  margin-bottom: 25px;
}
.cooperation-main .div2 div p label {
  font-weight: 600;
}
.cooperation-main .pthy-img-box {
  position: relative;
}
.cooperation-main .pthy-img-box .a-btn {
  position: absolute;
  width: 190px;
  height: 190px;
  top: 53.5%;
  left: 49.9%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}
.bg2 {
  background: url(../images/bg-lx.png) no-repeat center;
  background-size: cover;
}
.bg4 {
  background: url(../images/bg-lx2.png) no-repeat center;
  background-size: cover;
}
.box-kf {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
  padding-bottom: 100px;
}
.box-kf .span1 {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  color: #FFFFFF;
  line-height: 42px;
}
.box-kf p {
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 50px;
}
.box-kf img {
  width: 176px;
  height: 176px;
  margin-top: 40px;
  margin-bottom: 10px;
}
.box-kf .span2 {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  color: #FFFFFF;
  line-height: 28px;
}
.box-lxwm {
  display: flex;
  justify-content: center;
  padding-top: 45px;
  padding-bottom: 45px;
}
.box-lxwm dl dt {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #303133;
  line-height: 28px;
  text-align: center;
}
.box-lxwm dl dt img {
  width: 176px;
  height: 176px;
  margin-top: 5px;
  margin-bottom: 20px;
}
.box-lxwm dl dd {
  font-size: 26px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #303133;
  line-height: 50px;
  text-align: center;
  margin-bottom: 20px;
}
.activity-main .ban {
  background: url(../images/ban-8.png) center;
  background-size: cover;
}
.activity-main .div1 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.activity-main .div1 > a {
    font-size: 16px;
    color: #666666;
  border-radius: 50% ;
  border: 3px solid #DCDFE6 !important; 
  width: 132px;
  height: 132px;
  text-align: center;
  line-height: 126px;
  box-sizing: border-box;
}
.activity-main .div1 > a.active {
  border-color: #EB263B !important;
}
.activity-main .div1 > i {
  overflow: hidden;
  /* margin: 0; */
  /* width: 240px; */
  flex: 1;
  height: 0;
  border-top: 3px solid #DCDFE6;
}
.activity-main .ul1 {
  display: flex;
  justify-content: space-between;
}
.activity-main .ul1 li {
  width: 236px;
  height: 400px;
  border-radius: 4px;
  border: 1px solid rgba(235, 38, 59, 0.33);
}
.activity-main .ul1 li .s1 {
  text-align: center;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #EF2A37;
  line-height: 42px;
}
.activity-main .ul1 li > div {
  cursor: pointer;
  height: 100%;
  box-sizing: border-box;
  padding: 30px;
  /* display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center; */
  /* text-align: center; */
  /* transition:all 1s */
}
.activity-main .ul1 li > div img {
  display: block;
  width: 98px;
  height: 98px;
  margin: 15px auto 20px;
}
.activity-main .ul1 li .s2 {
  text-align: center;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #909399;
  line-height: 25px;
  letter-spacing: 6px;
  margin-top: 3px;
}
.activity-main .ul1 li .s3 {
  margin-top: 30px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  line-height: 25px;
}
.activity-main .ul1 li:hover {
  border-color: #eb263b;
  box-shadow: 0px 2px 13px 0px rgba(74, 95, 127, 0.17);
}
.activity-main .libao-list {
  display: flex;
  justify-content: space-between;
}
.activity-main .libao-list > div {
  position: relative;
  transform-style: preserve-3d;
  perspective: 1000px;
}
.activity-main .libao-list > div > dl {
  width: 380px;
  height: 380px;
  position: relative;
  transform-style: preserve-3d;
  transition: all 1s;
  transform: rotateY(180deg);
}
.activity-main .libao-list > div > dl dt {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 1;
  border-radius: 6px;
  box-shadow: 0px 2px 13px 0px rgba(74, 95, 127, 0.17);
  transform: rotateY(180deg);
}
.activity-main .libao-list > div > dl dt span {
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #fff;
}
.activity-main .libao-list > div > dl .dt1 {
  background: url(../images/img-5-1.png) center;
  background-size: cover;
}
.activity-main .libao-list > div > dl .dt2 {
  background: url(../images/img-5-2.png) center;
  background-size: cover;
}
.activity-main .libao-list > div > dl .dt3 {
  background: url(../images/img-5-3.png) center;
  background-size: cover;
}
.activity-main .libao-list > div > dl dd {
  display: flex;
  flex-direction: column;
  padding: 50px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 2px 13px 0px rgba(74, 95, 127, 0.17);
  transform: translateZ(10px);
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
}
.activity-main .libao-list > div > dl dd > ul {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.activity-main .libao-list > div > dl dd > ul li {
  display: flex;
  align-items: center;
}
.activity-main .libao-list > div > dl dd > ul li img {
  height: 42px;
  margin-right: 20px;
}
.activity-main .libao-list > div > dl dd > ul li .img2 {
  width: 34px;
  height: 34px;
  object-fit: contain;
}
.activity-main .libao-list > div > dl dd > ul li span {
  color: #303133;
  font-size: 20px;
}
.activity-main .libao-list > div > dl dd > p {
  text-align: center;
  color: #5294F9;
  font-size: 14px;
  margin-top: 40px;
}
.activity-main .libao-list > div > dl dd > p > a {
  font-size: 14px;
  color: #5294F9;
  text-decoration: underline;
}
.activity-main .libao-list > div:hover > dl {
  transform: rotateY(0deg);
}
.activity-main .div2 {
  display: flex;
}
.activity-main .div2 > dl {
  overflow: hidden;
  flex: 1;
  height: 397px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #C0C4CC;
  display: flex;
  flex-direction: column;
}
.activity-main .div2 > dl > dt {
  height: 129px;
  text-align: center;
  line-height: 129px;
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  padding: 0;
}
.activity-main .div2 > dl > dt.dt1 {
  background: url(../images/img-bg-1.png) center;
  background-size: 105%;
}
.activity-main .div2 > dl > dt.dt2 {
  background: url(../images/img-bg-2.png) center;
  background-size: 105%;
}
.activity-main .div2 > dl > dd {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.activity-main .div2 > dl > dd p {
  /* font-family: PingFangSC-Medium, PingFang SC; */
  /* font-weight: 300; */
  color: #303133;
  line-height: 33px;
}
.activity-main .div2 > dl > dd p label {
  width: 250px;
  display: inline-block;
  font-size: 20px;
}
.activity-main .div2 > dl > dd p span {
  font-size: 24px;
  width: 120px;
  display: inline-block;
  color: #303133;
  font-weight: 500;
}
.activity-main .div2 > dl > dd p span .font1 {
  color: #5294F9;
}
.activity-main .div2 > dl > dd p span .font2 {
  color: #EB263B;
}
.activity-main .div2 > dl > dd p + p {
  margin-top: 34px;
}
.activity-main .div2 > dl + dl {
  margin-left: 66px;
}
.activity-main .note {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #303133;
  line-height: 29px;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
}
.activity-main font {
  color: #EB263B;
}
.activity-main .table1 {
  border-collapse: collapse;
  border: 1px solid #C0C4CC;
  border-color: #C0C4CC;
  width: 100%;
}
.activity-main .table1 thead tr {
  background-color: #F9FAFB;
  height: 40px;
}
.activity-main .table1 tbody tr {
  font-size: 16px;
}
.activity-main .table1 tr {
  height: 35px;
}
.activity-main .table1 th,
.activity-main .table1 td {
  border: 1px solid #C0C4CC;
  padding: 0 25px;
  font-size: 14px;
}
.activity-main .table1 tr th:nth-last-child(1),
.activity-main .table1 tr th:nth-last-child(2),
.activity-main .table1 tr td:nth-last-child(1),
.activity-main .table1 tr td:nth-last-child(2) {
  text-align: center;
}
.activity-main .jrtj {
  border: 1px solid #C0C4CC;
  color: 24px;
  line-height: 33px;
  color: #303133;
}
.activity-main .jrtj .d1 {
  display: flex;
}
.activity-main .jrtj .d1 > div {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 120px;
}
.activity-main .jrtj .d1 > div img {
  width: 27px;
  height: 27px;
  margin-bottom: 15px;
}
.activity-main .jrtj .d1 > div span {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  line-height: 22px;
}
.activity-main .jrtj .d1 > div + div {
  border-left: 1px solid #C0C4CC;
}
.activity-main .jrtj .d2 {
  border-top: 1px solid #C0C4CC;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.activity-main .jrtj .d2 img {
  width: 27px;
  height: 27px;
  margin-right: 6px;
}
.activity-main .jrtj .d2 span {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  line-height: 22px;
}
.activity-main .tab1 {
  height: 58px;
  display: flex;
  overflow: hidden;
}
.activity-main .tab1 li {
  flex: 1;
  height: 58px;
  line-height: 58px;
  position: relative;
  background-color: #F5F7FA;
  font-size: 20px;
  /* font-family: PingFangSC-Regular, PingFang SC; */
  /* font-weight: 400; */
  color: #303133;
  text-align: center;
  padding-left: 38px;
}
.activity-main .tab1 li:before {
  content: '';
  display: block;
  position: absolute;
  height: 50px;
  width: 50px;
  background-color: #fff;
  transform: rotateZ(45deg);
  top: 4px;
  right: -30px;
  z-index: 1;
}
.activity-main .tab1 li:after {
  content: '';
  display: block;
  position: absolute;
  height: 50px;
  width: 50px;
  background-color: #F5F7FA;
  transform: rotateZ(45deg);
  top: 4px;
  right: -20px;
  z-index: 2;
}
.activity-main .tab1 li.active {
  background-color: #5294F9;
  color: #fff;
}
.activity-main .tab1 li.active:after {
  background-color: #5294F9;
}
.activity-main .qyxx {
  border: 1px solid #C0C4CC;
}
.activity-main .qyxx > li {
  display: flex;
}
.activity-main .qyxx > li > div {
  height: 60px;
  padding: 0 20px;
  display: flex;
  align-items: center;
}
.activity-main .qyxx > li > div + div {
  border-left: 1px solid #C0C4CC;
}
.activity-main .qyxx > li .label {
  width: 300px;
}
.activity-main .qyxx > li input {
  border: none;
  outline: none;
  width: 100%;
}
.activity-main .qyxx li + li {
  border-top: 1px solid #C0C4CC;
}
.activity-main .qyxx .box {
  flex: 1;
}
.activity-main .qyxx .box .file-name {
  color: #5294F9;
  margin-left: 15px;
}
.activity-main .xxsh .p4 {
  height: 69px;
  padding: 0 20px;
  margin-top: 20px;
  border: 1px solid #C0C4CC;
  display: flex;
  align-items: center;
}
.activity-main .xxsh .p4 p {
  flex: 1;
  color: #303133;
  font-size: 16px;
}
.activity-main .xxsh .p4 p label {
  font-weight: 600;
}
.activity-main .bhyy {
  text-align: center;
  color: #E54C4A;
  margin-top: 15px;
  margin-bottom: 15px;
}
.activity-main .sqrz-con {
  border: 1px solid #C0C4CC;
}
.activity-main .sqrz-con .top {
  border-bottom: 1px solid #C0C4CC;
  display: flex;
  align-items: center;
  min-height: 60px;
  padding: 10px 30px;
  box-sizing: border-box;
}
.activity-main .sqrz-con .top > div {
  flex: 1;
}
.activity-main .sqrz-con .top2 {
  border-bottom: 1px solid #C0C4CC;
  display: flex;
  align-items: center;
  padding: 15px 30px;
}
.activity-main .sqrz-con .top2 > div {
  flex: 1;
}
.activity-main .sqrz-con .top2 > div p + p {
  margin-top: 10px;
}
.activity-main .sqrz-con .top2 > div p .s1 {
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.activity-main .sqrz-con .top2 > div p .s2 {
  font-family: PingFangSC-Regular, PingFang SC;
}
.activity-main .sqrz-con .bottom-box {
  padding: 15px 30px;
  border-top: 1px solid #C0C4CC;
}
.activity-main .sqrz-con .bottom-box .bottom {
  display: flex;
}
.activity-main .sqrz-con .bottom-box .bottom .s1 {
  line-height: 32px;
  color: #303133;
  margin-right: 10px;
}
.activity-main .sqrz-con .bottom-box .bottom .s2 {
  line-height: 32px;
  color: #E54C4A;
  margin-right: 10px;
}
.activity-main .sqrz-con .bottom-box .bottom .a1 {
  line-height: 32px;
  color: #5294F9;
  margin-right: 10px;
}
.activity-main .sqrz-con .item1 {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;
  padding: 0 30px;
}
.activity-main .sqrz-con .item2 {
  border-top: 1px solid #EBEEF5;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;
  margin: 0 30px;
}
.activity-main .sqrz-con .item2 .item3 {
  width: 500px;
}
.activity-main .sqrz-con .item3 {
  display: flex;
  align-items: center;
}
.activity-main .sqrz-con .item3 + .item3 {
  margin-top: 24px;
}
.activity-main .sqrz-con .item3 .name {
  width: 90px;
  font-size: 18px;
  color: #303133;
  font-weight: 500;
}
.activity-main .sqrz-con .item3 .input-block {
  flex: 1;
  position: relative;
}
.activity-main .sqrz-con .item3 .input-block .tip {
  position: absolute;
  bottom: -20px;
  font-size: 12px;
  color: #e54c4a;
  line-height: 20px;
}
.activity-main .sqrz-con .item4 {
  display: flex;
  padding: 0 30px;
}
.activity-main .sqrz-con .item4 .item3 {
  margin-top: 0;
}
.activity-main .sqrz-con .item4 .item5 {
  padding: 30px 0;
  flex: 1;
  display: flex;
  align-items: center;
  margin-right: 100px;
  border-right: 1px solid #EBEEF5;
}
.activity-main .sqrz-con .item4 .item6 {
  padding: 30px 0;
  width: 50%;
}
.activity-main .ht-list {
  margin-left: 10px;
  width: 200px;
  padding-top: 5px;
}
.activity-main .ht-list > li {
  padding-left: 5px;
  padding-right: 2px;
  display: flex;
  align-items: center;
}
.activity-main .ht-list > li > span {
  color: #5294F9;
  font-size: 14px;
  line-height: 20px;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.activity-main .ht-list > li > i {
  cursor: pointer;
  width: 16px;
  height: 16px;
  background: url(../images/icon-no.svg) center no-repeat;
  background-size: contain;
  margin-left: 5px;
}
.activity-main .ht-list > li:hover {
  background-color: #F5F7FA;
}
.activity-main .xf-box {
  text-align: center;
  margin-top: 20px;
}
.activity-main .xf-box p {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #E54C4A;
  line-height: 25px;
  margin-bottom: 10px;
  text-align: center;
}
.look-ht-list {
  width: 500px;
  padding: 30px;
}
.look-ht-list > li {
  line-height: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #5294F9;
}
.look-ht-list > li > a {
  color: #5294F9;
  font-size: 14px;
}
.xy-box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-up {
  width: 144px;
  height: 32px;
  background: #5294F9;
  border-radius: 2px;
  color: #fff;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
}
.box-yycj {
  display: flex;
}
.box-yycj .ul1 {
  margin-right: 90px;
}
.box-yycj .ul1 li {
  font-size: 22px;
  color: #303133;
  line-height: 30px;
  padding: 10px 35px 10px 25px;
  margin-bottom: 30px;
  cursor: pointer;
}
.box-yycj .ul1 li.active {
  color: #5294F9;
  background: url(../images/bg-label.png) center no-repeat;
  background-size: 100% 100%;
}
.box-yycj .div1 {
  flex: 1;
  margin-right: 90px;
}
.box-yycj .div1 .p1 {
  height: 28px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #303133;
  line-height: 28px;
  margin-bottom: 30px;
}
.box-yycj .div1 .ul2 li {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  line-height: 60px;
}
.box-yycj .div1 a {
  font-size: 21px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5294F9;
  line-height: 48px;
}
.box-yycj .div2 {
  width: 50%;
  max-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.box-yycj .div2 .img-box {
  position: relative;
}
.box-yycj .div2 .img-box img {
  width: 100%;
  max-height: 600px;
  object-fit: contain;
}
.box-yycj .div2 .img-box a {
  display: none;
  position: absolute;
}
.box-yycj .div2 .img-box .a1 {
  width: 75.5%;
  height: 60%;
  right: 0;
  top: 0;
  z-index: 1;
}
.box-yycj .div2 .img-box .a2 {
  width: 70.5%;
  height: 78%;
  left: 0;
  bottom: 1%;
  z-index: 2;
}
.box-yycj-4 .t1 {
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #303133;
  line-height: 42px;
}
.box-yycj-4 .p1 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  line-height: 28px;
}
.box-yycj-4 .d1 {
  margin-top: 50px;
  margin-bottom: 50px;
}
.box-yycj-4 .img1 {
  display: block;
  width: 90%;
  margin: 0 auto;
}
.box-fwlx {
  position: relative;
  background-color: rgba(19, 32, 52, 0.85);
}
.box-fwlx::after {
  content: '';
  position: absolute;
  z-index: -1;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-image: url(../images/bg4.jpg);
  background-size: cover;
}
.box-fwlx .box-fwlx-con {
  display: flex;
  align-items: center;
}
.box-fwlx .box-fwlx-con .div1 {
  margin-right: 50px;
  width: calc(50% - 110px);
  margin-bottom: -25px;
}
.box-fwlx .box-fwlx-con .div1 p {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 25px;
}
.box-fwlx .box-fwlx-con .div1 img {
  width: 165px;
  height: 165px;
  margin-top: 8px;
  margin-bottom: 84px;
}
.box-fwlx .box-fwlx-con .div1 span {
  font-size: 40px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 56px;
  margin-top: 8px;
}
.box-fwlx .box-fwlx-con .ul1 {
  width: calc(50% + 110px);
  overflow: hidden;
  margin-bottom: -25px;
}
.box-fwlx .box-fwlx-con .ul1 li {
  width: calc(100% - 35px);
  float: left;
  margin-left: 35px;
  margin-bottom: 25px;
}
.box-fwlx .box-fwlx-con .ul1 li label {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 20px;
  margin-bottom: 5px;
}
.box-fwlx .box-fwlx-con .ul1 li input {
  width: 100%;
  height: 34px;
  border: 0;
  outline: none;
  display: block;
  box-sizing: border-box;
  padding: 0 5px;
  border-radius: 2px;
}
.box-fwlx .box-fwlx-con .ul1 li textarea {
  display: block;
  height: 130px;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  border: none;
  padding: 5px;
  border-radius: 2px;
}
.box-fwlx .box-fwlx-con .ul1 li .btn {
  display: block;
  width: 100%;
  height: 40px;
  background-color: #0065FF;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  text-align: center;
}
.box-fwlx .box-fwlx-con .ul1 .li1 {
  width: calc((100% - 70px) / 2);
}
.box-fwlx .box-fwlx-con-2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.box-fwlx .box-fwlx-con-2 p {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 25px;
}
.box-fwlx .box-fwlx-con-2 img {
  width: 165px;
  height: 165px;
  margin-top: 8px;
  margin-bottom: 30px;
}
.box-fwlx .box-fwlx-con-2 span {
  font-size: 40px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 56px;
}
.login-box {
  width: 492px;
  box-sizing: border-box;
  padding: 30px;
}
.login-box .input-block {
  margin-bottom: 20px;
}
.login-box .btn-sub {
  display: block;
  color: #fff;
  font-size: 14px;
  line-height: 32px;
  text-align: center;
  height: 32px;
  background: #5294F9;
  border-radius: 2px;
}
.login-box .login-foot {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  font-size: 13px;
}
.login-box .login-foot a {
  color: #5294F9;
}
.login-box .login-foot span {
  color: #909399;
}
.dialog-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  display: none;
}
.dialog-box .dialog-bg {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.dialog-box .dialog-bg .dialog {
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0px 4px 15px 0px rgba(0, 18, 41, 0.19);
}
.dialog-box .dialog-bg .dialog .d-head {
  height: 40px;
  background-color: #F9FAFB;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  border-radius: 2px 2px 0 0;
}
.dialog-box .dialog-bg .dialog .d-head .d-title {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  line-height: 22px;
}
.dialog-box .dialog-bg .dialog .d-head .d-close {
  width: 20px;
  height: 20px;
  margin-left: 20px;
  cursor: pointer;
}
.dialog-box .dialog-bg .dialog .d-con {
  max-height: 800px;
  overflow: auto;
}
.input-block {
  height: 32px;
  display: flex;
  align-items: center;
  border: 1px solid #DCDFE6;
  border-radius: 2px;
  padding: 0 5px;
  font-size: 14px;
}
.input-block .input-item {
  flex: 1;
  outline: none;
  border: none;
}
.input-block .icon-img {
  height: 16px;
  width: 16px;
  object-fit: contain;
  cursor: pointer;
  margin-left: 10px;
}
.input-box {
  display: flex;
}
.input-box .input-block {
  flex: 1;
}
.input-box .code-btn {
  margin-left: 15px;
  width: 110px;
}
.input-box .code-btn.is-off {
  background-color: #d4d4d4;
}
.btn-text {
  color: #5294F9;
}
.btn {
  display: inline-block;
  padding: 0 20px;
  box-sizing: border-box;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  background: #5294F9;
  border-radius: 2px;
}
.btn2 {
  display: inline-block;
  padding: 0 20px;
  box-sizing: border-box;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  background: #5294F9;
  border-radius: 2px;
}
.s-status {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #303133;
}
.s-status img {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  object-fit: contain;
}
.s-checkbox {
  display: inline-block;
  width: 22px;
  height: 22px;
  border: 1px solid #CED4DF;
  border-radius: 4px;
  text-align: center;
  line-height: 20px;
  cursor: pointer;
}
.s-checkbox.checked {
  border-color: #6BC73C;
  color: #6BC73C;
}
.s-checkbox.checked:after {
  content: '✓';
}
.s-radio {
  cursor: pointer;
  display: flex;
}
.s-radio + .s-radio {
  margin-left: 30px;
}
.s-radio i {
  display: block;
  width: 20px;
  height: 20px;
  border: 1px solid #CED4DF;
  border-radius: 50%;
  position: relative;
}
.s-radio span {
  margin-left: 10px;
  font-size: 16px;
  color: #303133;
}
.s-radio.checked i {
  border-color: #5294F9;
}
.s-radio.checked i::after {
  content: '';
  display: block;
  position: absolute;
  top: 5px;
  bottom: 5px;
  left: 5px;
  right: 5px;
  border-radius: 50%;
  background: #5294F9;
}
.s-radio.disabled {
  cursor: no-drop;
}
.s-radio.disabled i {
  border-color: #CED4DF;
}
.s-radio.disabled i::after {
  background: #CED4DF;
}
.s-radio.disabled span {
  color: #999;
}

.pay-con {
  width: 600px;
  padding: 25px 90px;
}
.pay-con .div1 {
  display: flex;
  justify-content: center;
}
.pay-con .p1 {
  color: #303133;
  margin-bottom: 15px;
}
.pay-con .p1 label {
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.pay-con .p1 span {
  font-family: PingFangSC-Regular, PingFang SC;
}
.pay-con .p2 {
  text-align: center;
  margin-top: 15px;
  margin-bottom: 30px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.pay-con .p3 {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}
.pay-con .p4 {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  line-height: 20px;
  margin-top: 10px;
  margin-bottom: 7px;
}
.pay-con .table1 {
  border-collapse: collapse;
  border: 1px solid #EBEEF5;
  width: 100%;
}
.pay-con .table1 td {
  color: #E54C4A;
  font-size: 14px;
  height: 30px;
  padding: 0 10px;
  border: 1px solid #EBEEF5;
}
.pay-con .table1 td.td2 {
  text-align: right;
}
.pay-con .div2 {
  border: 1px solid #EBEEF5;
  padding: 10px;
}
.pay-con .div2 > p {
  font-size: 14px;
  line-height: 20px;
  color: #303133;
}
.pay-con .div2 > p + p {
  margin-top: 4px;
}
.pay-con .p5 {
  margin-top: 20px;
  font-size: 14px;
  text-align: center;
  color: #E54C4A;
}
.pay-con .div3 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.pay-con .div3 > span {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #E54C4A;
  line-height: 26px;
  margin-bottom: 5px;
}
.pay-con .div3 .img1 {
  width: 139px;
  height: 139px;
  border: 1px solid #6BC73C;
}
.pay-con .div3 .img1 img {
  width: 100%;
  height: 100%;
}
.pay-con .div3 .img1 canvas {
  display: none;
}
.pay-con .div3 .p6 {
  display: flex;
  align-items: center;
  margin-top: 5px;
}
.pay-con .div3 .p6 > img {
  width: 14px;
  height: 14px;
  margin-right: 5px;
}
.pay-con .div3 .p6 > span {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #C0C4CC;
}
.invoice-detail,
.form-invoice {
  width: 650px;
  padding: 25px;
}
.invoice-detail .p1,
.form-invoice .p1 {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #303133;
  line-height: 22px;
  margin-bottom: 20px;
}
.s-form .item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.s-form .item > label {
  width: 90px;
  margin-right: 10px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  line-height: 22px;
}
.s-form .item .text {
  flex: 1;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  line-height: 22px;
}
.s-form .item .form-input {
  flex: 1;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  line-height: 30px;
  padding: 0 5px;
  height: 30px;
  border: 1px solid #DCDFE6;
  border-radius: 2px;
  outline: none;
}
.s-form .item .form-input-block {
  flex: 1;
  display: flex;
}
.s-form .item .form-input-block .form-input + .form-input {
  margin-left: 10px;
}
.s-form .item-textarea {
  align-items: flex-start;
}
.s-form .item-textarea > label {
  line-height: 32px;
}
.s-form .item-textarea .form-textarea {
  flex: 1;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  line-height: 18px;
  padding: 5px;
  height: 50px;
  border: 1px solid #DCDFE6;
  border-radius: 2px;
  outline: none;
}
.invoice-detail .status-bar {
  display: flex;
  align-items: center;
  margin-bottom: 70px;
  margin-left: 10px;
}
.invoice-detail .status-bar .line {
  height: 3px;
  width: 95px;
  background-color: #DCDFE6;
}
.invoice-detail .status-bar .icon {
  position: relative;
  width: 30px;
  height: 30px;
}
.invoice-detail .status-bar .icon img {
  width: 30px;
  height: 30px;
}
.invoice-detail .status-bar .icon .img1 {
  display: none;
}
.invoice-detail .status-bar .icon div {
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  text-align: center;
  font-size: 14px;
}
.invoice-detail .status-bar.status2 .line {
  background-color: #6BC73C;
}
.invoice-detail .status-bar.status2 .icon .img2 {
  display: none;
}
.invoice-detail .status-bar.status2 .icon .img1 {
  display: block;
}
.zixun {
  width: 50px;
  background: #FFFFFF;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.22);
  border-radius: 24px;
  position: fixed;
  z-index: 100;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}
.zixun .line {
  margin: 0 10px;
  height: 0.5px;
  background-color: #DCDFE6;
}
.zixun > .item {
  padding: 15px 0;
  text-align: center;
  cursor: pointer;
  position: relative;
}
.zixun > .item > img {
  width: 30px;
  height: 30px;
}
.zixun > .item > span {
  display: block;
  text-align: center;
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #303133;
  line-height: 20px;
}
.zixun > .item .phone {
  background: #fff;
  font-size: 22px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #303133;
  line-height: 40px;
  border-radius: 6px;
  padding: 0 20px;
  white-space: nowrap;
}
.zixun > .item .img-kf {
  background: #fff;
  border-radius: 6px;
}
.zixun > .item .img-kf > img {
  width: 165px;
  height: 165px;
  border-radius: 6px;
}
.zixun > .item .msg {
  display: none;
  background: #fff;
  position: absolute;
  right: 60px;
  top: 50%;
  transform: translateY(-50%);
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.22);
  transition: all 1s;
}
.zixun > .item .msg::after {
  content: '';
  display: block;
  width: 15px;
  height: 15px;
  background: #fff;
  transform: rotate(45deg) translateY(-50%);
  position: absolute;
  right: 0;
  top: 50%;
}
.zixun > .item:first-child {
  padding-top: 20px;
}
.zixun > .item:last-child {
  padding-bottom: 20px;
}
.zixun > .item1 {
  border-radius: 22px 22px 0px 0px;
}
.zixun > .item1:hover .msg {
  display: block;
}
.zixun > .item2 {
  background: #5294F9;
  border-radius: 0px 0px 22px 22px;
}
.zixun > .item2 > span {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 20px;
}
.zixun > .item2 .zx-msg {
  padding: 25px 20px;
  border-radius: 6px;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.22);
}

</style>
<style>
#toastId {
  display: block !important;
  color: #fff !important;
  font-size: 16px !important;
  line-height: 20px !important;
  padding: 10px 20px !important;
  border-radius: 4px !important;
  background-color: rgba(0, 0, 0, 0.7) !important;
  position: fixed !important;
  z-index: 999999999 !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}
</style>


// WEBPACK FOOTER //
// src/page/activity.vue